import React__default, { createElement, createContext, useContext, useState, useCallback, useEffect, Fragment, Children, isValidElement, cloneElement, useLayoutEffect, useRef, useMemo, forwardRef as forwardRef$1 } from 'react';
import cx from 'clsx';
import { render as render$1, unmountComponentAtNode, createPortal } from 'react-dom';
import FocusLock from 'react-focus-lock';
import { useId } from '@reach/auto-id';
var Color;

(function (Color) {
  Color["Transparent"] = "transparent";
  Color["PrimaryLightest"] = "primary-lightest";
  Color["PrimaryLighter"] = "primary-lighter";
  Color["PrimaryLight"] = "primary-light";
  Color["Primary"] = "primary";
  Color["PrimaryDark"] = "primary-dark";
  Color["PrimaryDarker"] = "primary-darker";
  Color["PrimaryDarkest"] = "primary-darkest";
  Color["SecondaryLightest"] = "secondary-lightest";
  Color["SecondaryLighter"] = "secondary-lighter";
  Color["SecondaryLight"] = "secondary-light";
  Color["Secondary"] = "secondary";
  Color["SecondaryDark"] = "secondary-dark";
  Color["SecondaryDarker"] = "secondary-darker";
  Color["SecondaryDarkest"] = "secondary-darkest";
  Color["TertiaryLightest"] = "tertiary-lightest";
  Color["TertiaryLighter"] = "tertiary-lighter";
  Color["TertiaryLight"] = "tertiary-light";
  Color["Tertiary"] = "tertiary";
  Color["TertiaryDark"] = "tertiary-dark";
  Color["TertiaryDarker"] = "tertiary-darker";
  Color["TertiaryDarkest"] = "tertiary-darkest";
  Color["QuaternaryLightest"] = "quaternary-lightest";
  Color["QuaternaryLighter"] = "quaternary-lighter";
  Color["QuaternaryLight"] = "quaternary-light";
  Color["Quaternary"] = "quaternary";
  Color["QuaternaryDark"] = "quaternary-dark";
  Color["QuaternaryDarker"] = "quaternary-darker";
  Color["QuaternaryDarkest"] = "quaternary-darkest";
  Color["White"] = "white";
  Color["Neutral100"] = "neutral-100";
  Color["Neutral200"] = "neutral-200";
  Color["Neutral300"] = "neutral-300";
  Color["Neutral400"] = "neutral-400";
  Color["Neutral500"] = "neutral-500";
  Color["Neutral600"] = "neutral-600";
  Color["Neutral700"] = "neutral-700";
  Color["Neutral800"] = "neutral-800";
  Color["Black"] = "black";
  Color["SuccessLightest"] = "success-lightest";
  Color["SuccessLighter"] = "success-lighter";
  Color["SuccessLight"] = "success-light";
  Color["Success"] = "success";
  Color["SuccessDark"] = "success-dark";
  Color["SuccessDarker"] = "success-darker";
  Color["SuccessDarkest"] = "success-darkest";
  Color["WarningLightest"] = "warning-lightest";
  Color["WarningLighter"] = "warning-lighter";
  Color["WarningLight"] = "warning-light";
  Color["Warning"] = "warning";
  Color["WarningDark"] = "warning-dark";
  Color["WarningDarker"] = "warning-darker";
  Color["WarningDarkest"] = "warning-darkees";
  Color["AlertLightest"] = "alert-lightest";
  Color["AlertLighter"] = "alert-lighter";
  Color["AlertLight"] = "alert-light";
  Color["Alert"] = "alert";
  Color["AlertDark"] = "alert-dark";
  Color["AlertDarker"] = "alert-darker";
  Color["AlertDarkest"] = "alert-darkest";
})(Color || (Color = {}));

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function getDefaultColor(color) {
  if (!color) return false;
  return Array.isArray(color) ? color[0] : color;
}

function getHoverColor(color) {
  if (!color) return false;
  return Array.isArray(color) ? color[1] : color;
}

var Corners;

(function (Corners) {
  Corners["Square"] = "square";
  Corners["SmallRounded"] = "small";
  Corners["LargeRounded"] = "large";
  Corners["MediumRounded"] = "medium";
  Corners["FullRounded"] = "full";
})(Corners || (Corners = {}));

var Shadow;

(function (Shadow) {
  Shadow["None"] = "none";
  Shadow["Base"] = "base";
  Shadow["Medium"] = "md";
  Shadow["Large"] = "lg";
  Shadow["ExtraLarge"] = "xl";
})(Shadow || (Shadow = {}));

function getPaddingClassNames(padding) {
  var length = Array.isArray(padding) ? padding.length : 0;

  if (length === 4) {
    var pt;

    switch (Array.isArray(padding) && padding[0]) {
      case 0:
        pt = "pt-0";
        break;

      case 1:
        pt = "pt-1";
        break;

      case 2:
        pt = "pt-2";
        break;

      case 3:
        pt = "pt-3";
        break;

      case 4:
        pt = "pt-4";
        break;

      case 5:
        pt = "pt-5";
        break;

      case 6:
        pt = "pt-6";
        break;

      case 8:
        pt = "pt-8";
        break;

      case 10:
        pt = "pt-10";
        break;

      case 12:
        pt = "pt-12";
        break;

      case 16:
        pt = "pt-16";
        break;

      case 20:
        pt = "pt-20";
        break;

      case 24:
        pt = "pt-24";
        break;

      case 32:
        pt = "pt-32";
        break;

      case 40:
        pt = "pt-40";
        break;

      case 48:
        pt = "pt-48";
        break;

      case 56:
        pt = "pt-56";
        break;

      case 64:
        pt = "pt-64";
        break;

      case "px":
      default:
        {
          pt = "pt-px";
          break;
        }
    }

    var pr;

    switch (Array.isArray(padding) && padding[1]) {
      case 0:
        pr = "pr-0";
        break;

      case 1:
        pr = "pr-1";
        break;

      case 2:
        pr = "pr-2";
        break;

      case 3:
        pr = "pr-3";
        break;

      case 4:
        pr = "pr-4";
        break;

      case 5:
        pr = "pr-5";
        break;

      case 6:
        pr = "pr-6";
        break;

      case 8:
        pr = "pr-8";
        break;

      case 10:
        pr = "pr-10";
        break;

      case 12:
        pr = "pr-12";
        break;

      case 16:
        pr = "pr-16";
        break;

      case 20:
        pr = "pr-20";
        break;

      case 24:
        pr = "pr-24";
        break;

      case 32:
        pr = "pr-32";
        break;

      case 40:
        pr = "pr-40";
        break;

      case 48:
        pr = "pr-48";
        break;

      case 56:
        pr = "pr-56";
        break;

      case 64:
        pr = "pr-64";
        break;

      case "px":
      default:
        {
          pr = "pr-px";
          break;
        }
    }

    var pb;

    switch (Array.isArray(padding) && padding[2]) {
      case 0:
        pb = "pb-0";
        break;

      case 1:
        pb = "pb-1";
        break;

      case 2:
        pb = "pb-2";
        break;

      case 3:
        pb = "pb-3";
        break;

      case 4:
        pb = "pb-4";
        break;

      case 5:
        pb = "pb-5";
        break;

      case 6:
        pb = "pb-6";
        break;

      case 8:
        pb = "pb-8";
        break;

      case 10:
        pb = "pb-10";
        break;

      case 12:
        pb = "pb-12";
        break;

      case 16:
        pb = "pb-16";
        break;

      case 20:
        pb = "pb-20";
        break;

      case 24:
        pb = "pb-24";
        break;

      case 32:
        pb = "pb-32";
        break;

      case 40:
        pb = "pb-40";
        break;

      case 48:
        pb = "pb-48";
        break;

      case 56:
        pb = "pb-56";
        break;

      case 64:
        pb = "pb-64";
        break;

      case "px":
      default:
        {
          pb = "pb-px";
          break;
        }
    }

    var pl;

    switch (Array.isArray(padding) && padding[3]) {
      case 0:
        pl = "pl-0";
        break;

      case 1:
        pl = "pl-1";
        break;

      case 2:
        pl = "pl-2";
        break;

      case 3:
        pl = "pl-3";
        break;

      case 4:
        pl = "pl-4";
        break;

      case 5:
        pl = "pl-5";
        break;

      case 6:
        pl = "pl-6";
        break;

      case 8:
        pl = "pl-8";
        break;

      case 10:
        pl = "pl-10";
        break;

      case 12:
        pl = "pl-12";
        break;

      case 16:
        pl = "pl-16";
        break;

      case 20:
        pl = "pl-20";
        break;

      case 24:
        pl = "pl-24";
        break;

      case 32:
        pl = "pl-32";
        break;

      case 40:
        pl = "pl-40";
        break;

      case 48:
        pl = "pl-48";
        break;

      case 56:
        pl = "pl-56";
        break;

      case 64:
        pl = "pl-64";
        break;

      case "px":
      default:
        {
          pl = "pl-px";
          break;
        }
    }

    return [pt, pr, pb, pl];
  }

  if (length === 2) {
    var py;

    switch (Array.isArray(padding) && padding[0]) {
      case 0:
        py = "py-0";
        break;

      case 1:
        py = "py-1";
        break;

      case 2:
        py = "py-2";
        break;

      case 3:
        py = "py-3";
        break;

      case 4:
        py = "py-4";
        break;

      case 5:
        py = "py-5";
        break;

      case 6:
        py = "py-6";
        break;

      case 8:
        py = "py-8";
        break;

      case 10:
        py = "py-10";
        break;

      case 12:
        py = "py-12";
        break;

      case 16:
        py = "py-16";
        break;

      case 20:
        py = "py-20";
        break;

      case 24:
        py = "py-24";
        break;

      case 32:
        py = "py-32";
        break;

      case 40:
        py = "py-40";
        break;

      case 48:
        py = "py-48";
        break;

      case 56:
        py = "py-56";
        break;

      case 64:
        py = "py-64";
        break;

      case "px":
      default:
        {
          py = "py-px";
          break;
        }
    }

    var px;

    switch (Array.isArray(padding) && padding[1]) {
      case 0:
        px = "px-0";
        break;

      case 1:
        px = "px-1";
        break;

      case 2:
        px = "px-2";
        break;

      case 3:
        px = "px-3";
        break;

      case 4:
        px = "px-4";
        break;

      case 5:
        px = "px-5";
        break;

      case 6:
        px = "px-6";
        break;

      case 8:
        px = "px-8";
        break;

      case 10:
        px = "px-10";
        break;

      case 12:
        px = "px-12";
        break;

      case 16:
        px = "px-16";
        break;

      case 20:
        px = "px-20";
        break;

      case 24:
        px = "px-24";
        break;

      case 32:
        px = "px-32";
        break;

      case 40:
        px = "px-40";
        break;

      case 48:
        px = "px-48";
        break;

      case 56:
        px = "px-56";
        break;

      case 64:
        px = "px-64";
        break;

      case "px":
      default:
        {
          px = "px-px";
          break;
        }
    }

    return [py, px];
  }

  switch (padding) {
    case 0:
      return "p-0";

    case 1:
      return "p-1";

    case 2:
      return "p-2";

    case 3:
      return "p-3";

    case 4:
      return "p-4";

    case 5:
      return "p-5";

    case 6:
      return "p-6";

    case 8:
      return "p-8";

    case 10:
      return "p-10";

    case 12:
      return "p-12";

    case 16:
      return "p-16";

    case 20:
      return "p-20";

    case 24:
      return "p-24";

    case 32:
      return "p-32";

    case 40:
      return "p-40";

    case 48:
      return "p-48";

    case 56:
      return "p-56";

    case 64:
      return "p-64";

    case "px":
    default:
      {
        return "p-px";
      }
  }
}

function Frame(_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? "div" : _ref$as,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$bg = _ref.bg,
      bg = _ref$bg === void 0 ? Color.Transparent : _ref$bg,
      border = _ref.border,
      _ref$shadow = _ref.shadow,
      shadow = _ref$shadow === void 0 ? Shadow.None : _ref$shadow,
      _ref$corners = _ref.corners,
      corners = _ref$corners === void 0 ? Corners.Square : _ref$corners,
      _ref$p = _ref.p,
      p = _ref$p === void 0 ? 0 : _ref$p,
      innerRef = _ref.innerRef,
      props = _objectWithoutPropertiesLoose(_ref, ["as", "className", "bg", "border", "shadow", "corners", "p", "innerRef"]);

  var hasHoverBG = Array.isArray(bg) && bg.length === 2;
  var hasHoverBorder = Array.isArray(border) && border.length === 2;
  var cn = cx( // Corners
  {
    "rounded-none": corners === Corners.Square,
    "rounded-full": corners === Corners.FullRounded,
    "rounded-sm": corners === Corners.SmallRounded,
    rounded: corners === Corners.MediumRounded,
    "rounded-lg": corners === Corners.LargeRounded
  }, // Shadows
  {
    "shadow-none": shadow === Shadow.None,
    shadow: shadow === Shadow.Base,
    "shadow-md": shadow === Shadow.Medium,
    "shadow-lg": shadow === Shadow.Large,
    "shadow-xl": shadow === Shadow.ExtraLarge
  }, // Background
  {
    "bg-transparent": getDefaultColor(bg) === Color.Transparent,
    "bg-primary-lightest": getDefaultColor(bg) === Color.PrimaryLightest,
    "bg-primary-lighter": getDefaultColor(bg) === Color.PrimaryLighter,
    "bg-primary-light": getDefaultColor(bg) === Color.PrimaryLight,
    "bg-primary-base": getDefaultColor(bg) === Color.Primary,
    "bg-primary-dark": getDefaultColor(bg) === Color.PrimaryDark,
    "bg-primary-darker": getDefaultColor(bg) === Color.PrimaryDarker,
    "bg-primary-darkest": getDefaultColor(bg) === Color.PrimaryDarkest,
    "bg-secondary-lightest": getDefaultColor(bg) === Color.SecondaryLightest,
    "bg-secondary-lighter": getDefaultColor(bg) === Color.SecondaryLighter,
    "bg-secondary-light": getDefaultColor(bg) === Color.SecondaryLight,
    "bg-secondary-base": getDefaultColor(bg) === Color.Secondary,
    "bg-secondary-dark": getDefaultColor(bg) === Color.SecondaryDark,
    "bg-secondary-darker": getDefaultColor(bg) === Color.SecondaryDarker,
    "bg-secondary-darkest": getDefaultColor(bg) === Color.SecondaryDarkest,
    "bg-tertiary-lightest": getDefaultColor(bg) === Color.TertiaryLightest,
    "bg-tertiary-lighter": getDefaultColor(bg) === Color.TertiaryLighter,
    "bg-tertiary-light": getDefaultColor(bg) === Color.TertiaryLight,
    "bg-tertiary-base": getDefaultColor(bg) === Color.Tertiary,
    "bg-tertiary-dark": getDefaultColor(bg) === Color.TertiaryDark,
    "bg-tertiary-darker": getDefaultColor(bg) === Color.TertiaryDarker,
    "bg-tertiary-darkest": getDefaultColor(bg) === Color.TertiaryDarkest,
    "bg-quaternary-lightest": getDefaultColor(bg) === Color.QuaternaryLightest,
    "bg-quaternary-lighter": getDefaultColor(bg) === Color.QuaternaryLighter,
    "bg-quaternary-light": getDefaultColor(bg) === Color.QuaternaryLight,
    "bg-quaternary-base": getDefaultColor(bg) === Color.Quaternary,
    "bg-quaternary-dark": getDefaultColor(bg) === Color.QuaternaryDark,
    "bg-quaternary-darker": getDefaultColor(bg) === Color.QuaternaryDarker,
    "bg-quaternary-darkest": getDefaultColor(bg) === Color.QuaternaryDarkest,
    "bg-white": getDefaultColor(bg) === Color.White,
    "bg-neutral-100": getDefaultColor(bg) === Color.Neutral100,
    "bg-neutral-200": getDefaultColor(bg) === Color.Neutral200,
    "bg-neutral-300": getDefaultColor(bg) === Color.Neutral300,
    "bg-neutral-400": getDefaultColor(bg) === Color.Neutral400,
    "bg-neutral-500": getDefaultColor(bg) === Color.Neutral500,
    "bg-neutral-600": getDefaultColor(bg) === Color.Neutral600,
    "bg-neutral-700": getDefaultColor(bg) === Color.Neutral700,
    "bg-neutral-800": getDefaultColor(bg) === Color.Neutral800,
    "bg-black": getDefaultColor(bg) === Color.Black,
    "bg-success-lightest": getDefaultColor(bg) === Color.SuccessLightest,
    "bg-success-lighter": getDefaultColor(bg) === Color.SuccessLighter,
    "bg-success-light": getDefaultColor(bg) === Color.SuccessLight,
    "bg-success-base": getDefaultColor(bg) === Color.Success,
    "bg-success-dark": getDefaultColor(bg) === Color.SuccessDark,
    "bg-success-darker": getDefaultColor(bg) === Color.SuccessDarker,
    "bg-success-darkest": getDefaultColor(bg) === Color.SuccessDarkest,
    "bg-warning-lightest": getDefaultColor(bg) === Color.WarningLightest,
    "bg-warning-lighter": getDefaultColor(bg) === Color.WarningLighter,
    "bg-warning-light": getDefaultColor(bg) === Color.WarningLight,
    "bg-warning-base": getDefaultColor(bg) === Color.Warning,
    "bg-warning-dark": getDefaultColor(bg) === Color.WarningDark,
    "bg-warning-darker": getDefaultColor(bg) === Color.WarningDarker,
    "bg-warning-darkest": getDefaultColor(bg) === Color.WarningDarkest,
    "bg-alert-lightest": getDefaultColor(bg) === Color.AlertLightest,
    "bg-alert-lighter": getDefaultColor(bg) === Color.AlertLighter,
    "bg-alert-light": getDefaultColor(bg) === Color.AlertLight,
    "bg-alert-base": getDefaultColor(bg) === Color.Alert,
    "bg-alert-dark": getDefaultColor(bg) === Color.AlertDark,
    "bg-alert-darker": getDefaultColor(bg) === Color.AlertDarker,
    "bg-alert-darkest": getDefaultColor(bg) === Color.AlertDarkest
  }, hasHoverBG ? {
    "hover:bg-transparent": getDefaultColor(bg) === Color.Transparent,
    "hover:bg-primary-lightest": getHoverColor(bg) === Color.PrimaryLightest,
    "hover:bg-primary-lighter": getHoverColor(bg) === Color.PrimaryLighter,
    "hover:bg-primary-light": getHoverColor(bg) === Color.PrimaryLight,
    "hover:bg-primary-base": getHoverColor(bg) === Color.Primary,
    "hover:bg-primary-dark": getHoverColor(bg) === Color.PrimaryDark,
    "hover:bg-primary-darker": getHoverColor(bg) === Color.PrimaryDarker,
    "hover:bg-primary-darkest": getHoverColor(bg) === Color.PrimaryDarkest,
    "hover:bg-secondary-lightest": getHoverColor(bg) === Color.SecondaryLightest,
    "hover:bg-secondary-lighter": getHoverColor(bg) === Color.SecondaryLighter,
    "hover:bg-secondary-light": getHoverColor(bg) === Color.SecondaryLight,
    "hover:bg-secondary-base": getHoverColor(bg) === Color.Secondary,
    "hover:bg-secondary-dark": getHoverColor(bg) === Color.SecondaryDark,
    "hover:bg-secondary-darker": getHoverColor(bg) === Color.SecondaryDarker,
    "hover:bg-secondary-darkest": getHoverColor(bg) === Color.SecondaryDarkest,
    "hover:bg-tertiary-lightest": getHoverColor(bg) === Color.TertiaryLightest,
    "hover:bg-tertiary-lighter": getHoverColor(bg) === Color.TertiaryLighter,
    "hover:bg-tertiary-light": getHoverColor(bg) === Color.TertiaryLight,
    "hover:bg-tertiary-base": getHoverColor(bg) === Color.Tertiary,
    "hover:bg-tertiary-dark": getHoverColor(bg) === Color.TertiaryDark,
    "hover:bg-tertiary-darker": getHoverColor(bg) === Color.TertiaryDarker,
    "hover:bg-tertiary-darkest": getHoverColor(bg) === Color.TertiaryDarkest,
    "hover:bg-quaternary-lightest": getHoverColor(bg) === Color.QuaternaryLightest,
    "hover:bg-quaternary-lighter": getHoverColor(bg) === Color.QuaternaryLighter,
    "hover:bg-quaternary-light": getHoverColor(bg) === Color.QuaternaryLight,
    "hover:bg-quaternary-base": getHoverColor(bg) === Color.Quaternary,
    "hover:bg-quaternary-dark": getHoverColor(bg) === Color.QuaternaryDark,
    "hover:bg-quaternary-darker": getHoverColor(bg) === Color.QuaternaryDarker,
    "hover:bg-quaternary-darkest": getHoverColor(bg) === Color.QuaternaryDarkest,
    "hover:bg-white": getHoverColor(bg) === Color.White,
    "hover:bg-neutral-100": getHoverColor(bg) === Color.Neutral100,
    "hover:bg-neutral-200": getHoverColor(bg) === Color.Neutral200,
    "hover:bg-neutral-300": getHoverColor(bg) === Color.Neutral300,
    "hover:bg-neutral-400": getHoverColor(bg) === Color.Neutral400,
    "hover:bg-neutral-500": getHoverColor(bg) === Color.Neutral500,
    "hover:bg-neutral-600": getHoverColor(bg) === Color.Neutral600,
    "hover:bg-neutral-700": getHoverColor(bg) === Color.Neutral700,
    "hover:bg-neutral-800": getHoverColor(bg) === Color.Neutral800,
    "hover:bg-black": getHoverColor(bg) === Color.Black,
    "bg-success-lighter": getHoverColor(bg) === Color.SuccessLighter,
    "hover:bg-success-lightest": getHoverColor(bg) === Color.SuccessLightest,
    "hover:bg-success-lighter": getHoverColor(bg) === Color.SuccessLighter,
    "hover:bg-success-light": getHoverColor(bg) === Color.SuccessLight,
    "hover:bg-success-base": getHoverColor(bg) === Color.Success,
    "hover:bg-success-dark": getHoverColor(bg) === Color.SuccessDark,
    "hover:bg-success-darker": getHoverColor(bg) === Color.SuccessDarker,
    "hover:bg-success-darkest": getHoverColor(bg) === Color.SuccessDarkest,
    "hover:bg-warning-lightest": getHoverColor(bg) === Color.WarningLightest,
    "hover:bg-warning-lighter": getHoverColor(bg) === Color.WarningLighter,
    "hover:bg-warning-light": getHoverColor(bg) === Color.WarningLight,
    "hover:bg-warning-base": getHoverColor(bg) === Color.Warning,
    "hover:bg-warning-dark": getHoverColor(bg) === Color.WarningDark,
    "hover:bg-warning-darker": getHoverColor(bg) === Color.WarningDarker,
    "hover:bg-warning-darkest": getHoverColor(bg) === Color.WarningDarkest,
    "hover:bg-alert-lightest": getHoverColor(bg) === Color.AlertLightest,
    "hover:bg-alert-lighter": getHoverColor(bg) === Color.AlertLighter,
    "hover:bg-alert-light": getHoverColor(bg) === Color.AlertLight,
    "hover:bg-alert-base": getHoverColor(bg) === Color.Alert,
    "hover:bg-alert-dark": getHoverColor(bg) === Color.AlertDark,
    "hover:bg-alert-darker": getHoverColor(bg) === Color.AlertDarker,
    "hover:bg-alert-darkest": getHoverColor(bg) === Color.AlertDarkest
  } : false, // Border
  {
    "border border-solid": Boolean(border),
    "border-transparent": getDefaultColor(border) === Color.Transparent,
    "border-primary-lightest": getDefaultColor(border) === Color.PrimaryLightest,
    "border-primary-lighter": getDefaultColor(border) === Color.PrimaryLighter,
    "border-primary-light": getDefaultColor(border) === Color.PrimaryLight,
    "border-primary-base": getDefaultColor(border) === Color.Primary,
    "border-primary-dark": getDefaultColor(border) === Color.PrimaryDark,
    "border-primary-darker": getDefaultColor(border) === Color.PrimaryDarker,
    "border-primary-darkest": getDefaultColor(border) === Color.PrimaryDarkest,
    "border-secondary-lightest": getDefaultColor(border) === Color.SecondaryLightest,
    "border-secondary-lighter": getDefaultColor(border) === Color.SecondaryLighter,
    "border-secondary-light": getDefaultColor(border) === Color.SecondaryLight,
    "border-secondary-base": getDefaultColor(border) === Color.Secondary,
    "border-secondary-dark": getDefaultColor(border) === Color.SecondaryDark,
    "border-secondary-darker": getDefaultColor(border) === Color.SecondaryDarker,
    "border-secondary-darster": getDefaultColor(border) === Color.SecondaryDarkest,
    "border-tertiary-lightest": getDefaultColor(border) === Color.TertiaryLightest,
    "border-tertiary-lighter": getDefaultColor(border) === Color.TertiaryLighter,
    "border-tertiary-light": getDefaultColor(border) === Color.TertiaryLight,
    "border-tertiary-base": getDefaultColor(border) === Color.Tertiary,
    "border-tertiary-dark": getDefaultColor(border) === Color.TertiaryDark,
    "border-tertiary-darker": getDefaultColor(border) === Color.TertiaryDarker,
    "border-tertiary-darkstr": getDefaultColor(border) === Color.TertiaryDarkest,
    "border-quaternary-lightest": getDefaultColor(border) === Color.QuaternaryLightest,
    "border-quaternary-lighter": getDefaultColor(border) === Color.QuaternaryLighter,
    "border-quaternary-light": getDefaultColor(border) === Color.QuaternaryLight,
    "border-quaternary-base": getDefaultColor(border) === Color.Quaternary,
    "border-quaternary-dark": getDefaultColor(border) === Color.QuaternaryDark,
    "border-quaternary-darker": getDefaultColor(border) === Color.QuaternaryDarker,
    "border-quaternary-darster": getDefaultColor(border) === Color.QuaternaryDarkest,
    "border-white": getDefaultColor(border) === Color.White,
    "border-neutral-100": getDefaultColor(border) === Color.Neutral100,
    "border-neutral-200": getDefaultColor(border) === Color.Neutral200,
    "border-neutral-300": getDefaultColor(border) === Color.Neutral300,
    "border-neutral-400": getDefaultColor(border) === Color.Neutral400,
    "border-neutral-500": getDefaultColor(border) === Color.Neutral500,
    "border-neutral-600": getDefaultColor(border) === Color.Neutral600,
    "border-neutral-700": getDefaultColor(border) === Color.Neutral700,
    "border-neutral-800": getDefaultColor(border) === Color.Neutral800,
    "border-black": getDefaultColor(border) === Color.Black,
    "border-success-lightest": getDefaultColor(border) === Color.SuccessLightest,
    "border-success-lighter": getDefaultColor(border) === Color.SuccessLighter,
    "border-success-light": getDefaultColor(border) === Color.SuccessLight,
    "border-success-base": getDefaultColor(border) === Color.Success,
    "border-success-dark": getDefaultColor(border) === Color.SuccessDark,
    "border-success-darker": getDefaultColor(border) === Color.SuccessDarker,
    "border-success-darkest": getDefaultColor(border) === Color.SuccessDarkest,
    "border-warning-lightest": getDefaultColor(border) === Color.WarningLightest,
    "border-warning-lighter": getDefaultColor(border) === Color.WarningLighter,
    "border-warning-light": getDefaultColor(border) === Color.WarningLight,
    "border-warning-base": getDefaultColor(border) === Color.Warning,
    "border-warning-dark": getDefaultColor(border) === Color.WarningDark,
    "border-warning-darker": getDefaultColor(border) === Color.WarningDarker,
    "border-warning-darkest": getDefaultColor(border) === Color.WarningDarkest,
    "border-alert-lightest": getDefaultColor(border) === Color.AlertLightest,
    "border-alert-lighter": getDefaultColor(border) === Color.AlertLighter,
    "border-alert-light": getDefaultColor(border) === Color.AlertLight,
    "border-alert-base": getDefaultColor(border) === Color.Alert,
    "border-alert-dark": getDefaultColor(border) === Color.AlertDark,
    "border-alert-darker": getDefaultColor(border) === Color.AlertDarker,
    "border-alert-darkest": getDefaultColor(border) === Color.AlertDarkest
  }, hasHoverBorder ? {
    "hover:border-transparent": getDefaultColor(border) === Color.Transparent,
    "hover:border-primary-lightest": getHoverColor(border) === Color.PrimaryLightest,
    "hover:border-primary-lighter": getHoverColor(border) === Color.PrimaryLighter,
    "hover:border-primary-light": getHoverColor(border) === Color.PrimaryLight,
    "hover:border-primary-base": getHoverColor(border) === Color.Primary,
    "hover:border-primary-dark": getHoverColor(border) === Color.PrimaryDark,
    "hover:border-primary-darker": getHoverColor(border) === Color.PrimaryDarker,
    "hover:border-primary-darkest": getHoverColor(border) === Color.PrimaryDarkest,
    "hover:border-secondary-lightest": getHoverColor(border) === Color.SecondaryLightest,
    "hover:border-secondary-lighter": getHoverColor(border) === Color.SecondaryLighter,
    "hover:border-secondary-light": getHoverColor(border) === Color.SecondaryLight,
    "hover:border-secondary-base": getHoverColor(border) === Color.Secondary,
    "hover:border-secondary-dark": getHoverColor(border) === Color.SecondaryDark,
    "hover:border-secondary-darker": getHoverColor(border) === Color.SecondaryDarker,
    "hover:border-secondary-darkest": getHoverColor(border) === Color.SecondaryDarkest,
    "hover:border-tertiary-lightest": getHoverColor(border) === Color.TertiaryLightest,
    "hover:border-tertiary-lighter": getHoverColor(border) === Color.TertiaryLighter,
    "hover:border-tertiary-light": getHoverColor(border) === Color.TertiaryLight,
    "hover:border-tertiary-base": getHoverColor(border) === Color.Tertiary,
    "hover:border-tertiary-dark": getHoverColor(border) === Color.TertiaryDark,
    "hover:border-tertiary-darker": getHoverColor(border) === Color.TertiaryDarker,
    "hover:border-tertiary-darkest": getHoverColor(border) === Color.TertiaryDarkest,
    "hover:border-quaternary-lightest": getHoverColor(border) === Color.QuaternaryLightest,
    "hover:border-quaternary-lighter": getHoverColor(border) === Color.QuaternaryLighter,
    "hover:border-quaternary-light": getHoverColor(border) === Color.QuaternaryLight,
    "hover:border-quaternary-base": getHoverColor(border) === Color.Quaternary,
    "hover:border-quaternary-dark": getHoverColor(border) === Color.QuaternaryDark,
    "hover:border-quaternary-darker": getHoverColor(border) === Color.QuaternaryDarker,
    "hover:border-quaternary-darkest": getHoverColor(border) === Color.QuaternaryDarkest,
    "hover:border-white": getHoverColor(border) === Color.White,
    "hover:border-neutral-100": getHoverColor(border) === Color.Neutral100,
    "hover:border-neutral-200": getHoverColor(border) === Color.Neutral200,
    "hover:border-neutral-300": getHoverColor(border) === Color.Neutral300,
    "hover:border-neutral-400": getHoverColor(border) === Color.Neutral400,
    "hover:border-neutral-500": getHoverColor(border) === Color.Neutral500,
    "hover:border-neutral-600": getHoverColor(border) === Color.Neutral600,
    "hover:border-neutral-700": getHoverColor(border) === Color.Neutral700,
    "hover:border-neutral-800": getHoverColor(border) === Color.Neutral800,
    "hover:border-black": getHoverColor(border) === Color.Black,
    "border-success-lightest": getHoverColor(border) === Color.SuccessLightest,
    "border-success-lighter": getHoverColor(border) === Color.SuccessLighter,
    "hover:border-success-light": getHoverColor(border) === Color.SuccessLight,
    "hover:border-success-base": getHoverColor(border) === Color.Success,
    "hover:border-success-dark": getHoverColor(border) === Color.SuccessDark,
    "hover:border-success-darker": getHoverColor(border) === Color.SuccessDarker,
    "hover:border-success-darkest": getHoverColor(border) === Color.SuccessDarkest,
    "hover:border-warning-lightest": getHoverColor(border) === Color.WarningLightest,
    "hover:border-warning-lighter": getHoverColor(border) === Color.WarningLighter,
    "hover:border-warning-light": getHoverColor(border) === Color.WarningLight,
    "hover:border-warning-base": getHoverColor(border) === Color.Warning,
    "hover:border-warning-darkest": getHoverColor(border) === Color.WarningDarkest,
    "hover:border-warning-darker": getHoverColor(border) === Color.WarningDarker,
    "hover:border-warning-dark": getHoverColor(border) === Color.WarningDark,
    "hover:border-alert-lightest": getHoverColor(border) === Color.AlertLightest,
    "hover:border-alert-lighter": getHoverColor(border) === Color.AlertLighter,
    "hover:border-alert-light": getHoverColor(border) === Color.AlertLight,
    "hover:border-alert-base": getHoverColor(border) === Color.Alert,
    "hover:border-alert-dark": getHoverColor(border) === Color.AlertDark,
    "hover:border-alert-darker": getHoverColor(border) === Color.AlertDarker,
    "hover:border-alert-darkest": getHoverColor(border) === Color.AlertDarkest
  } : false, getPaddingClassNames(p), className);
  var Component = as;
  return /*#__PURE__*/createElement(Component, Object.assign({
    className: cn,
    ref: innerRef
  }, props));
}

var FlexDirection;

(function (FlexDirection) {
  FlexDirection["Vertical"] = "vertical";
  FlexDirection["Horizontal"] = "horizontal";
})(FlexDirection || (FlexDirection = {}));

var FlexAlignment;

(function (FlexAlignment) {
  FlexAlignment["Start"] = "start";
  FlexAlignment["Center"] = "center";
  FlexAlignment["End"] = "end";
  FlexAlignment["Stretch"] = "stretch";
  FlexAlignment["Baseline"] = "baseline";
})(FlexAlignment || (FlexAlignment = {}));

var FlexDistribution;

(function (FlexDistribution) {
  FlexDistribution["Start"] = "start";
  FlexDistribution["Center"] = "center";
  FlexDistribution["End"] = "end";
  FlexDistribution["Between"] = "between";
  FlexDistribution["Around"] = "around";
})(FlexDistribution || (FlexDistribution = {}));

function Flex(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? FlexDirection.Horizontal : _ref$direction,
      _ref$alignment = _ref.alignment,
      alignment = _ref$alignment === void 0 ? FlexAlignment.Start : _ref$alignment,
      _ref$distribution = _ref.distribution,
      distribution = _ref$distribution === void 0 ? FlexDistribution.Start : _ref$distribution,
      _ref$wrap = _ref.wrap,
      wrap = _ref$wrap === void 0 ? false : _ref$wrap,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "direction", "alignment", "distribution", "wrap"]);

  var cn = cx("flex", {
    "flex-row": direction === FlexDirection.Horizontal,
    "flex-col": direction === FlexDirection.Vertical
  }, {
    "items-stretch": alignment === FlexAlignment.Stretch,
    "items-start": alignment === FlexAlignment.Start,
    "items-center": alignment === FlexAlignment.Center,
    "items-end": alignment === FlexAlignment.End,
    "items-baseline": alignment === FlexAlignment.Baseline
  }, {
    "justify-start": distribution === FlexDistribution.Start,
    "justify-center": distribution === FlexDistribution.Center,
    "justify-end": distribution === FlexDistribution.End,
    "justify-between": distribution === FlexDistribution.Between,
    "justify-around": distribution === FlexDistribution.Around
  }, {
    "flex-no-wrap": wrap === false,
    "flex-wrap": wrap === true
  }, className);
  return /*#__PURE__*/createElement(Frame, Object.assign({
    className: cn
  }, props));
}

function noop() {
  return undefined;
}

var AccordionValueContext = /*#__PURE__*/createContext(false);
var AccordionTogglerContext = /*#__PURE__*/createContext(noop);

function useAccordionValue() {
  return useContext(AccordionValueContext);
}

function useAccordionToggle() {
  return useContext(AccordionTogglerContext);
}

function useAccordion() {
  return [useAccordionValue(), useAccordionToggle()];
}

function Touchable(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["className"]);

  var cn = cx("cursor-pointer select-none appearance-none", "focus:outline-none focus-visible:shadow-outline", className);
  return /*#__PURE__*/createElement(Frame, Object.assign({
    className: cn
  }, props, {
    as: "button"
  }));
}

function AccordionGroup(_ref) {
  var children = _ref.children,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen;

  var _React$useState = useState(isOpen),
      _isOpen = _React$useState[0],
      setIsOpen = _React$useState[1];

  var toggle = useCallback(function () {
    setIsOpen(function (current) {
      return !current;
    });
  }, [setIsOpen]);
  useEffect(function () {
    setIsOpen(isOpen);
  }, [isOpen]);
  return /*#__PURE__*/createElement(AccordionValueContext.Provider, {
    value: _isOpen
  }, /*#__PURE__*/createElement(AccordionTogglerContext.Provider, {
    value: toggle
  }, children));
}

function AccordionTitle(_ref2) {
  var children = _ref2.children,
      _ref2$isDisabled = _ref2.isDisabled,
      isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled,
      _ref2$onClick = _ref2.onClick,
      onClick = _ref2$onClick === void 0 ? noop : _ref2$onClick,
      props = _objectWithoutPropertiesLoose(_ref2, ["children", "isDisabled", "onClick"]);

  var _useAccordion = useAccordion(),
      isOpen = _useAccordion[0],
      toggle = _useAccordion[1];

  var handleClick = useCallback(function (event) {
    if (!isDisabled) toggle();
    onClick(event);
  }, [isDisabled, toggle, onClick]);
  return /*#__PURE__*/createElement(Flex, Object.assign({
    as: isDisabled ? "div" : Touchable,
    direction: FlexDirection.Vertical,
    onClick: handleClick,
    disabled: isDisabled
  }, props), typeof children === "function" ? children({
    isOpen: isOpen
  }) : children);
}

function AccordionContent(_ref3) {
  var children = _ref3.children;
  var isOpen = useAccordionValue();
  if (!isOpen) return null;
  return /*#__PURE__*/createElement(Fragment, null, children);
}

function Accordion(_ref4) {
  var isOpen = _ref4.isOpen,
      isDisabled = _ref4.isDisabled,
      label = _ref4.label,
      children = _ref4.children,
      props = _objectWithoutPropertiesLoose(_ref4, ["isOpen", "isDisabled", "label", "children"]);

  return /*#__PURE__*/createElement(AccordionGroup, {
    isOpen: isOpen
  }, /*#__PURE__*/createElement(AccordionTitle, Object.assign({
    isDisabled: isDisabled
  }, props), label), /*#__PURE__*/createElement(AccordionContent, null, children));
}

function createResource(asyncFn) {
  var status = "pending";
  var result;
  var promise = asyncFn().then(function (data) {
    status = "success";
    result = data;
  }, function (error) {
    status = "error";
    result = error;
  });
  return {
    read: function read() {
      if (status === "pending") throw promise;
      if (status === "error") throw result;
      if (status === "success") return result;
      throw new Error("This should be impossible");
    }
  };
}

var cache = /*#__PURE__*/new Map();

function createImageResource(source) {
  var resource = cache.get(source);
  if (resource) return resource;
  resource = createResource(function () {
    return new Promise(function (resolve, reject) {
      var img = new window.Image();
      img.src = source;
      img.addEventListener("load", function () {
        return resolve(source);
      });
      img.addEventListener("error", function () {
        return reject(new Error("Failed to load image " + source));
      });
    });
  });
  cache.set(source, resource);
  return resource;
}

function Image(_ref) {
  var className = _ref.className,
      source = _ref.source,
      alt = _ref.alt,
      _ref$rounded = _ref.rounded,
      rounded = _ref$rounded === void 0 ? false : _ref$rounded,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? "eager" : _ref$loading,
      _ref$content = _ref.content,
      content = _ref$content === void 0 ? "contain" : _ref$content,
      _ref$suspense = _ref.suspense,
      suspense = _ref$suspense === void 0 ? false : _ref$suspense,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "source", "alt", "rounded", "loading", "content", "suspense"]);

  var cn = cx("select-none max-w-full", {
    "object-contain": content === "contain",
    "object-cover": content === "cover",
    "object-fill": content === "fill",
    "object-none": content === "none",
    "object-scale-down": content === "scale-down"
  }, className);
  if (suspense) createImageResource(source).read();
  return /*#__PURE__*/createElement(Frame, Object.assign({
    as: "img",
    className: cn,
    loading: loading,
    alt: alt,
    corners: rounded ? Corners.FullRounded : Corners.Square
  }, props, {
    src: source
  }));
}

function Avatar(_ref) {
  var className = _ref.className,
      source = _ref.source,
      name = _ref.name,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "source", "name"]);

  var cn = cx(className);
  return /*#__PURE__*/createElement(Image, Object.assign({
    source: source,
    alt: name,
    className: cn,
    rounded: true
  }, props, {
    content: "cover"
  }));
}

function getSpacing(space) {
  switch (space) {
    case "px":
      return "space-x-px";

    case "-px":
      return "-space-x-px";

    case 1:
      return "space-x-1";

    case 2:
      return "space-x-2";

    case 3:
      return "space-x-3";

    case 4:
      return "space-x-4";

    case 5:
      return "space-x-5";

    case 6:
      return "space-x-6";

    case 8:
      return "space-x-8";

    case 10:
      return "space-x-10";

    case 12:
      return "space-x-12";

    case 16:
      return "space-x-16";

    case 20:
      return "space-x-20";

    case 24:
      return "space-x-24";

    case 32:
      return "space-x-32";

    case 40:
      return "space-x-40";

    case 48:
      return "space-x-48";

    case 56:
      return "space-x-56";

    case 64:
      return "space-x-64";

    case -1:
      return "-space-x-1";

    case -2:
      return "-space-x-2";

    case -3:
      return "-space-x-3";

    case -4:
      return "-space-x-4";

    case -5:
      return "-space-x-5";

    case -6:
      return "-space-x-6";

    case -8:
      return "-space-x-8";

    case -10:
      return "-space-x-10";

    case -12:
      return "-space-x-12";

    case -16:
      return "-space-x-16";

    case -20:
      return "-space-x-20";

    case -24:
      return "-space-x-24";

    case -32:
      return "-space-x-32";

    case -40:
      return "-space-x-40";

    case -48:
      return "-space-x-48";

    case -56:
      return "-space-x-56";

    case -64:
      return "-space-x-64";

    case 0:
      return "space-x-0";

    default:
      return "";
  }
}

function Inline(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      space = _ref.space,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "space"]);

  var cn = cx(getSpacing(space), className);
  return /*#__PURE__*/createElement(Flex, Object.assign({
    wrap: false,
    alignment: FlexAlignment.Center
  }, props, {
    direction: FlexDirection.Horizontal,
    className: cn
  }));
}

function Center(props) {
  return /*#__PURE__*/createElement(Flex, Object.assign({}, props, {
    children: Children.only(props.children),
    alignment: FlexAlignment.Center,
    distribution: FlexDistribution.Center
  }));
}

var TextTracking;

(function (TextTracking) {
  TextTracking["Tighter"] = "tighter";
  TextTracking["Tight"] = "tight";
  TextTracking["Normal"] = "normal";
  TextTracking["Wide"] = "wide";
  TextTracking["Wider"] = "wider";
  TextTracking["Widest"] = "widest";
})(TextTracking || (TextTracking = {}));

var TextLeading;

(function (TextLeading) {
  TextLeading["None"] = "none";
  TextLeading["Tight"] = "tight";
  TextLeading["Snug"] = "snug";
  TextLeading["Normal"] = "normal";
  TextLeading["Relaxed"] = "relaxed";
  TextLeading["Loose"] = "loose";
})(TextLeading || (TextLeading = {}));

var TextWeight;

(function (TextWeight) {
  TextWeight["Hairline"] = "hairline";
  TextWeight["Thin"] = "thin";
  TextWeight["Light"] = "light";
  TextWeight["Normal"] = "normal";
  TextWeight["Medium"] = "medium";
  TextWeight["SemiBold"] = "semibold";
  TextWeight["Bold"] = "bold";
  TextWeight["ExtraBold"] = "extrabold";
  TextWeight["Black"] = "black";
})(TextWeight || (TextWeight = {}));

var TextSize;

(function (TextSize) {
  TextSize["XS"] = "xs";
  TextSize["SM"] = "sm";
  TextSize["Base"] = "base";
  TextSize["LG"] = "lg";
  TextSize["XL"] = "xl";
  TextSize["XL2"] = "2xl";
  TextSize["XL3"] = "3xl";
  TextSize["XL4"] = "4xl";
  TextSize["XL5"] = "5xl";
  TextSize["XL6"] = "6xl";
})(TextSize || (TextSize = {}));

var TextDecoration;

(function (TextDecoration) {
  TextDecoration["Underline"] = "underline";
  TextDecoration["LineThrough"] = "line-through";
  TextDecoration["None"] = "none";
})(TextDecoration || (TextDecoration = {}));

var TextTransform;

(function (TextTransform) {
  TextTransform["Upper"] = "upper";
  TextTransform["Lower"] = "lower";
  TextTransform["Capitalize"] = "capitalize";
  TextTransform["Normal"] = "normal";
})(TextTransform || (TextTransform = {}));

var TextWhitespace;

(function (TextWhitespace) {
  TextWhitespace["Normal"] = "normal";
  TextWhitespace["NoWrap"] = "no-wrap";
  TextWhitespace["Pre"] = "pre";
  TextWhitespace["PreLine"] = "pre-line";
  TextWhitespace["PreWrap"] = "pre-wrap";
})(TextWhitespace || (TextWhitespace = {}));

var TextWordBreak;

(function (TextWordBreak) {
  TextWordBreak["Normal"] = "normal";
  TextWordBreak["Words"] = "words";
  TextWordBreak["All"] = "all";
  TextWordBreak["Truncate"] = "truncate";
})(TextWordBreak || (TextWordBreak = {}));

function Text(_ref) {
  var className = _ref.className,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? "span" : _ref$as,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? Color.Black : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? TextSize.Base : _ref$size,
      _ref$weight = _ref.weight,
      weight = _ref$weight === void 0 ? TextWeight.Normal : _ref$weight,
      _ref$italic = _ref.italic,
      italic = _ref$italic === void 0 ? false : _ref$italic,
      _ref$tracking = _ref.tracking,
      tracking = _ref$tracking === void 0 ? TextTracking.Normal : _ref$tracking,
      _ref$leading = _ref.leading,
      leading = _ref$leading === void 0 ? TextLeading.None : _ref$leading,
      _ref$decoration = _ref.decoration,
      decoration = _ref$decoration === void 0 ? TextDecoration.None : _ref$decoration,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? TextTransform.Normal : _ref$transform,
      _ref$whitespace = _ref.whitespace,
      whitespace = _ref$whitespace === void 0 ? TextWhitespace.Normal : _ref$whitespace,
      _ref$wordBreak = _ref.wordBreak,
      wordBreak = _ref$wordBreak === void 0 ? TextWordBreak.Normal : _ref$wordBreak,
      _ref$srOnly = _ref.srOnly,
      srOnly = _ref$srOnly === void 0 ? false : _ref$srOnly,
      innerRef = _ref.innerRef,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "as", "color", "size", "weight", "italic", "tracking", "leading", "decoration", "transform", "whitespace", "wordBreak", "srOnly", "innerRef"]);

  var hasHoverColor = Array.isArray(color) && color.length === 2;
  var cn = cx({
    italic: italic === true,
    "not-italic": italic === false
  }, {
    "tracking-tighter": tracking === TextTracking.Tighter,
    "tracking-tight": tracking === TextTracking.Tight,
    "tracking-normal": tracking === TextTracking.Normal,
    "tracking-wide": tracking === TextTracking.Wide,
    "tracking-wider": tracking === TextTracking.Wider,
    "tracking-widest": tracking === TextTracking.Widest
  }, {
    "leading-none": leading === TextLeading.None,
    "leading-tight": leading === TextLeading.Tight,
    "leading-snug": leading === TextLeading.Snug,
    "leading-normal": leading === TextLeading.Normal,
    "leading-relaxed": leading === TextLeading.Relaxed,
    "leading-loose": leading === TextLeading.Loose
  }, {
    "font-hairline": weight === TextWeight.Hairline,
    "font-black": weight === TextWeight.Black,
    "font-bold": weight === TextWeight.Bold,
    "font-extrabold": weight === TextWeight.ExtraBold,
    "font-light": weight === TextWeight.Light,
    "font-medium": weight === TextWeight.Medium,
    "font-normal": weight === TextWeight.Normal,
    "font-semibold": weight === TextWeight.SemiBold,
    "font-thin": weight === TextWeight.Thin
  }, {
    "text-xs": size === TextSize.XS,
    "text-sm": size === TextSize.SM,
    "text-base": size === TextSize.Base,
    "text-lg": size === TextSize.LG,
    "text-xl": size === TextSize.XL,
    "text-2xl": size === TextSize.XL2,
    "text-3xl": size === TextSize.XL3,
    "text-4xl": size === TextSize.XL4,
    "text-5xl": size === TextSize.XL5,
    "text-6xl": size === TextSize.XL6
  }, {
    underline: decoration === TextDecoration.Underline,
    "line-through": decoration === TextDecoration.LineThrough,
    "no-underline": decoration === TextDecoration.None
  }, {
    uppercase: transform === TextTransform.Upper,
    lowercase: transform === TextTransform.Lower,
    capitalize: transform === TextTransform.Capitalize,
    "normal-case": transform === TextTransform.Normal
  }, {
    "whitespace-normal": whitespace === TextWhitespace.Normal,
    "whitespace-no-wrap": whitespace === TextWhitespace.NoWrap,
    "whitespace-pre": whitespace === TextWhitespace.Pre,
    "whitespace-pre-line": whitespace === TextWhitespace.PreLine,
    "whitespace-pre-wrap": whitespace === TextWhitespace.PreWrap
  }, {
    "break-normal": wordBreak === TextWordBreak.Normal,
    "break-words": wordBreak === TextWordBreak.Words,
    "break-all": wordBreak === TextWordBreak.All,
    truncate: wordBreak === TextWordBreak.Truncate
  }, {
    "sr-only": srOnly === true
  }, {
    "text-transparent": getDefaultColor(color) === Color.Transparent,
    "text-primary-lightest": getDefaultColor(color) === Color.PrimaryLightest,
    "text-primary-lighter": getDefaultColor(color) === Color.PrimaryLighter,
    "text-primary-light": getDefaultColor(color) === Color.PrimaryLight,
    "text-primary-base": getDefaultColor(color) === Color.Primary,
    "text-primary-dark": getDefaultColor(color) === Color.PrimaryDark,
    "text-primary-darker": getDefaultColor(color) === Color.PrimaryDarker,
    "text-primary-darkest": getDefaultColor(color) === Color.PrimaryDarkest,
    "text-secondary-lightest": getDefaultColor(color) === Color.SecondaryLightest,
    "text-secondary-lighter": getDefaultColor(color) === Color.SecondaryLighter,
    "text-secondary-light": getDefaultColor(color) === Color.SecondaryLight,
    "text-secondary-base": getDefaultColor(color) === Color.Secondary,
    "text-secondary-dark": getDefaultColor(color) === Color.SecondaryDark,
    "text-secondary-darker": getDefaultColor(color) === Color.SecondaryDarker,
    "text-secondary-darkest": getDefaultColor(color) === Color.SecondaryDarkest,
    "text-tertiary-lightest": getDefaultColor(color) === Color.TertiaryLightest,
    "text-tertiary-lighter": getDefaultColor(color) === Color.TertiaryLighter,
    "text-tertiary-light": getDefaultColor(color) === Color.TertiaryLight,
    "text-tertiary-base": getDefaultColor(color) === Color.Tertiary,
    "text-tertiary-dark": getDefaultColor(color) === Color.TertiaryDark,
    "text-tertiary-darker": getDefaultColor(color) === Color.TertiaryDarker,
    "text-tertiary-darkest": getDefaultColor(color) === Color.TertiaryDarkest,
    "text-quaternary-lightest": getDefaultColor(color) === Color.QuaternaryLightest,
    "text-quaternary-lighter": getDefaultColor(color) === Color.QuaternaryLighter,
    "text-quaternary-light": getDefaultColor(color) === Color.QuaternaryLight,
    "text-quaternary-base": getDefaultColor(color) === Color.Quaternary,
    "text-quaternary-dark": getDefaultColor(color) === Color.QuaternaryDark,
    "text-quaternary-darker": getDefaultColor(color) === Color.QuaternaryDarker,
    "text-quaternary-darkest": getDefaultColor(color) === Color.QuaternaryDarkest,
    "text-white": getDefaultColor(color) === Color.White,
    "text-neutral-100": getDefaultColor(color) === Color.Neutral100,
    "text-neutral-200": getDefaultColor(color) === Color.Neutral200,
    "text-neutral-300": getDefaultColor(color) === Color.Neutral300,
    "text-neutral-400": getDefaultColor(color) === Color.Neutral400,
    "text-neutral-500": getDefaultColor(color) === Color.Neutral500,
    "text-neutral-600": getDefaultColor(color) === Color.Neutral600,
    "text-neutral-700": getDefaultColor(color) === Color.Neutral700,
    "text-neutral-800": getDefaultColor(color) === Color.Neutral800,
    "text-black": getDefaultColor(color) === Color.Black,
    "text-success-lightest": getDefaultColor(color) === Color.SuccessLightest,
    "text-success-lighter": getDefaultColor(color) === Color.SuccessLighter,
    "text-success-light": getDefaultColor(color) === Color.SuccessLight,
    "text-success-base": getDefaultColor(color) === Color.Success,
    "text-success-dark": getDefaultColor(color) === Color.SuccessDark,
    "text-success-darker": getDefaultColor(color) === Color.SuccessDarker,
    "text-success-darkest": getDefaultColor(color) === Color.SuccessDarkest,
    "text-warning-lightest": getDefaultColor(color) === Color.WarningLightest,
    "text-warning-lighter": getDefaultColor(color) === Color.WarningLighter,
    "text-warning-light": getDefaultColor(color) === Color.WarningLight,
    "text-warning-base": getDefaultColor(color) === Color.Warning,
    "text-warning-dark": getDefaultColor(color) === Color.WarningDark,
    "text-warning-darker": getDefaultColor(color) === Color.WarningDarker,
    "text-warning-darkest": getDefaultColor(color) === Color.WarningDarkest,
    "text-alert-lightest": getDefaultColor(color) === Color.AlertLightest,
    "text-alert-lighter": getDefaultColor(color) === Color.AlertLighter,
    "text-alert-light": getDefaultColor(color) === Color.AlertLight,
    "text-alert-base": getDefaultColor(color) === Color.Alert,
    "text-alert-dark": getDefaultColor(color) === Color.AlertDark,
    "text-alert-darker": getDefaultColor(color) === Color.AlertDarker,
    "text-alert-darkest": getDefaultColor(color) === Color.AlertDarkest
  }, hasHoverColor ? {
    "hover:text-transparent": getDefaultColor(color) === Color.Transparent,
    "hover:text-primary-lighter": getHoverColor(color) === Color.PrimaryLighter,
    "hover:text-primary-light": getHoverColor(color) === Color.PrimaryLight,
    "hover:text-primary-base": getHoverColor(color) === Color.Primary,
    "hover:text-primary-dark": getHoverColor(color) === Color.PrimaryDark,
    "hover:text-primary-darker": getHoverColor(color) === Color.PrimaryDarker,
    "hover:text-secondary-lighter": getHoverColor(color) === Color.SecondaryLighter,
    "hover:text-secondary-light": getHoverColor(color) === Color.SecondaryLight,
    "hover:text-secondary-base": getHoverColor(color) === Color.Secondary,
    "hover:text-secondary-dark": getHoverColor(color) === Color.SecondaryDark,
    "hover:text-secondary-darker": getHoverColor(color) === Color.SecondaryDarker,
    "hover:text-tertiary-lighter": getHoverColor(color) === Color.TertiaryLighter,
    "hover:text-tertiary-light": getHoverColor(color) === Color.TertiaryLight,
    "hover:text-tertiary-base": getHoverColor(color) === Color.Tertiary,
    "hover:text-tertiary-dark": getHoverColor(color) === Color.TertiaryDark,
    "hover:text-tertiary-darker": getHoverColor(color) === Color.TertiaryDarker,
    "hover:text-white": getHoverColor(color) === Color.White,
    "hover:text-neutral-100": getHoverColor(color) === Color.Neutral100,
    "hover:text-neutral-200": getHoverColor(color) === Color.Neutral200,
    "hover:text-neutral-300": getHoverColor(color) === Color.Neutral300,
    "hover:text-neutral-400": getHoverColor(color) === Color.Neutral400,
    "hover:text-neutral-500": getHoverColor(color) === Color.Neutral500,
    "hover:text-neutral-600": getHoverColor(color) === Color.Neutral600,
    "hover:text-neutral-700": getHoverColor(color) === Color.Neutral700,
    "hover:text-neutral-800": getHoverColor(color) === Color.Neutral800,
    "hover:text-black": getHoverColor(color) === Color.Black,
    "text-success-lighter": getHoverColor(color) === Color.SuccessLighter,
    "hover:text-success-light": getHoverColor(color) === Color.SuccessLight,
    "hover:text-success-base": getHoverColor(color) === Color.Success,
    "hover:text-success-dark": getHoverColor(color) === Color.SuccessDark,
    "hover:text-success-darker": getHoverColor(color) === Color.SuccessDarker,
    "hover:text-warning-lighter": getHoverColor(color) === Color.WarningLighter,
    "hover:text-warning-light": getHoverColor(color) === Color.WarningLight,
    "hover:text-warning-base": getHoverColor(color) === Color.Warning,
    "hover:text-warning-dark": getHoverColor(color) === Color.WarningDark,
    "hover:text-warning-darker": getHoverColor(color) === Color.WarningDarker,
    "hover:text-alert-lighter": getHoverColor(color) === Color.AlertLighter,
    "hover:text-alert-light": getHoverColor(color) === Color.AlertLight,
    "hover:text-alert-base": getHoverColor(color) === Color.Alert,
    "hover:text-alert-dark": getHoverColor(color) === Color.AlertDark,
    "hover:text-alert-darker": getHoverColor(color) === Color.AlertDarker
  } : false, className);
  var Component = as;
  return /*#__PURE__*/createElement(Component, Object.assign({
    className: cn,
    ref: innerRef
  }, props));
}

var AvatarSize;

(function (AvatarSize) {
  AvatarSize["XS"] = "xs";
  AvatarSize["SM"] = "sm";
  AvatarSize["Base"] = "base";
  AvatarSize["LG"] = "lg";
  AvatarSize["XL"] = "xl";
  AvatarSize["XL2"] = "2xl";
})(AvatarSize || (AvatarSize = {}));

function AvatarPlaceholder(_ref) {
  var extra = _ref.extra,
      size = _ref.size,
      textSize = _ref.textSize,
      className = _ref.className;
  var cn = cx({
    "w-6": size === AvatarSize.XS,
    "w-8": size === AvatarSize.SM,
    "w-12": size === AvatarSize.Base,
    "w-16": size === AvatarSize.LG,
    "w-24": size === AvatarSize.XL,
    "w-32": size === AvatarSize.XL2
  }, {
    "h-6": size === AvatarSize.XS,
    "h-8": size === AvatarSize.SM,
    "h-12": size === AvatarSize.Base,
    "h-16": size === AvatarSize.LG,
    "h-24": size === AvatarSize.XL,
    "h-32": size === AvatarSize.XL2
  }, className);
  return /*#__PURE__*/createElement(Center, {
    className: cn,
    bg: Color.Neutral100,
    border: Color.White,
    corners: Corners.FullRounded
  }, /*#__PURE__*/createElement(Text, {
    color: Color.Neutral400,
    size: textSize
  }, "+" + extra));
}

function AvatarGroup(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      _ref2$limit = _ref2.limit,
      limit = _ref2$limit === void 0 ? Infinity : _ref2$limit,
      placeholder = _ref2.placeholder,
      _ref2$space = _ref2.space,
      space = _ref2$space === void 0 ? -2 : _ref2$space,
      _ref2$forcePlaceholde = _ref2.forcePlaceholder,
      forcePlaceholder = _ref2$forcePlaceholde === void 0 ? false : _ref2$forcePlaceholde,
      props = _objectWithoutPropertiesLoose(_ref2, ["children", "className", "limit", "placeholder", "space", "forcePlaceholder"]);

  var cn = cx(className);
  var validChildren = Children.toArray(children).filter(function (child) {
    return /*#__PURE__*/isValidElement(child);
  });
  var count = validChildren.length;
  var extra = count - limit;
  var avatars = validChildren.slice(0, limit);

  var getPlaceholder = function getPlaceholder(extra) {
    if (!placeholder) return null;
    if (typeof placeholder === "function") return placeholder({
      extra: extra
    });
    return /*#__PURE__*/cloneElement(placeholder, {
      extra: extra
    });
  };

  var showPlaceholder = limit !== Infinity && count > avatars.length || forcePlaceholder;
  return /*#__PURE__*/createElement(Inline, Object.assign({
    space: space,
    className: cn,
    children: /*#__PURE__*/createElement(Fragment, null, avatars, placeholder && showPlaceholder && getPlaceholder(extra))
  }, props));
}

function Inset(_ref) {
  var className = _ref.className,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "static" : _ref$variant,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? "full" : _ref$position,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? "auto" : _ref$zIndex,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "variant", "position", "zIndex"]);

  var cn = cx( // position
  {
    fixed: variant === "fixed",
    relative: variant === "relative",
    "static": variant === "static",
    absolute: variant === "absolute"
  }, {
    "z-0": zIndex === 0,
    "z-10": zIndex === 10,
    "z-20": zIndex === 20,
    "z-30": zIndex === 30,
    "z-40": zIndex === 40,
    "z-50": zIndex === 50,
    "z-auto": zIndex === "auto"
  }, // full
  {
    "inset-0": position === "full",
    "inset-x-0 top-0": position === "top full",
    "inset-x-0 bottom-0": position === "bottom full",
    "inset-y-0 left-0": position === "left full",
    "inset-y-0 right-0": position === "right full"
  }, // corners
  {
    "top-0 left-0": position === "top left",
    "top-0 right-0": position === "top right",
    "bottom-0 left-0": position === "bottom left",
    "bottom-0 right-0": position === "bottom right"
  }, className);
  return /*#__PURE__*/createElement(Frame, Object.assign({
    className: cn
  }, props));
}

function Backdrop(_ref) {
  var className = _ref.className,
      _ref$opacity = _ref.opacity,
      opacity = _ref$opacity === void 0 ? 25 : _ref$opacity,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? "fixed" : _ref$position,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "opacity", "position"]);

  var cn = cx({
    "bg-opacity-0": opacity === 0,
    "bg-opacity-25": opacity === 25,
    "bg-opacity-50": opacity === 50,
    "bg-opacity-75": opacity === 75,
    "bg-opacity-100": opacity === 100
  }, className);
  return /*#__PURE__*/createElement(Inset, Object.assign({
    p: 12,
    bg: Color.Black,
    className: cn
  }, props, {
    zIndex: 10,
    variant: position,
    position: "full"
  }));
}

var ButtonVariant;

(function (ButtonVariant) {
  ButtonVariant["Solid"] = "solid";
  ButtonVariant["Outline"] = "outline";
  ButtonVariant["Ghost"] = "ghost";
  ButtonVariant["Link"] = "link";
})(ButtonVariant || (ButtonVariant = {}));

var ButtonState;

(function (ButtonState) {
  ButtonState["Normal"] = "normal";
  ButtonState["Disabled"] = "disabled";
  ButtonState["Loading"] = "loading";
})(ButtonState || (ButtonState = {}));

var ButtonSize;

(function (ButtonSize) {
  ButtonSize["ExtraSmall"] = "xs";
  ButtonSize["Small"] = "s";
  ButtonSize["Base"] = "base";
  ButtonSize["Medium"] = "medium";
  ButtonSize["Large"] = "l";
  ButtonSize["ExtraLarge"] = "xl";
})(ButtonSize || (ButtonSize = {}));

function getPaddingY(size) {
  if (size === ButtonSize.ExtraSmall) return 1;
  if (size === ButtonSize.ExtraLarge) return 3;
  if (size === ButtonSize.Medium) return 3;
  return 2;
}

function getPaddingX(size) {
  if (size === ButtonSize.ExtraSmall) return 6;
  if (size === ButtonSize.ExtraLarge) return 12;
  return 5;
}

function Button(_ref) {
  var children = _ref.children,
      color = _ref.color,
      variant = _ref.variant,
      className = _ref.className,
      size = _ref.size,
      state = _ref.state,
      block = _ref.block,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "color", "variant", "className", "size", "state", "block"]);

  var cn = cx("border border-solid", "leading-none", {
    "border-none": variant === ButtonVariant.Ghost || variant === ButtonVariant.Link
  }, // Cursor States
  {
    "cursor-wait": state === ButtonState.Loading,
    "cursor-not-allowed": state === ButtonState.Disabled
  }, // Size
  {
    "text-sm": size === ButtonSize.ExtraSmall || size === ButtonSize.Small,
    "text-base ": size === ButtonSize.Medium,
    "text-base": size === ButtonSize.Base,
    "text-lg": size === ButtonSize.Large || size === ButtonSize.ExtraLarge
  }, // Block
  {
    "w-full": block
  }, className);
  var bg = variant === ButtonVariant.Solid ? color : Color.White;
  var border = variant === ButtonVariant.Solid || variant === ButtonVariant.Outline ? color : Color.White;
  return /*#__PURE__*/createElement(Touchable, Object.assign({
    className: cn,
    disabled: state === ButtonState.Disabled || state === ButtonState.Loading,
    p: [getPaddingY(size), getPaddingX(size)],
    bg: bg,
    border: border,
    children: children
  }, props));
}

Button.defaultProps = {
  variant: ButtonVariant.Solid,
  color: Color.Primary,
  text: Color.White,
  state: ButtonState.Normal,
  block: false,
  size: ButtonSize.Base,
  shadow: Shadow.Base,
  corners: Corners.MediumRounded
};

function Cell(_ref) {
  var className = _ref.className,
      span = _ref.span,
      start = _ref.start,
      end = _ref.end,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "span", "start", "end"]);

  var cn = cx({
    "col-auto": span === "auto",
    "col-span-1": span === 1,
    "col-span-2": span === 2,
    "col-span-3": span === 3,
    "col-span-4": span === 4,
    "col-span-5": span === 5,
    "col-span-6": span === 6,
    "col-span-7": span === 7,
    "col-span-8": span === 8,
    "col-span-9": span === 9,
    "col-span-10": span === 10,
    "col-span-11": span === 11,
    "col-span-12": span === 12
  }, {
    "col-start-auto": start === "auto",
    "col-start-1": start === 1,
    "col-start-2": start === 2,
    "col-start-3": start === 3,
    "col-start-4": start === 4,
    "col-start-5": start === 5,
    "col-start-6": start === 6,
    "col-start-7": start === 7,
    "col-start-8": start === 8,
    "col-start-9": start === 9,
    "col-start-10": start === 10,
    "col-start-11": start === 11,
    "col-start-12": start === 12,
    "col-start-13": start === 13
  }, {
    "col-end-auto": end === "auto",
    "col-end-1": end === 1,
    "col-end-2": end === 2,
    "col-end-3": end === 3,
    "col-end-4": end === 4,
    "col-end-5": end === 5,
    "col-end-6": end === 6,
    "col-end-7": end === 7,
    "col-end-8": end === 8,
    "col-end-9": end === 9,
    "col-end-10": end === 10,
    "col-end-11": end === 11,
    "col-end-12": end === 12,
    "col-end-13": end === 13
  }, className);
  return /*#__PURE__*/createElement(Frame, Object.assign({
    className: cn
  }, props));
}

function useTextareaAutosize($element, minHeight, value) {
  useLayoutEffect(function () {
    if ($element && $element.current && minHeight !== false) {
      $element.current.style.height = 0;
      var newHeight = Math.max($element.current.scrollHeight, minHeight);
      $element.current.style.height = newHeight + "px";
    }
  }, [minHeight, $element, value]);
}

function useCombinedRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  var targetRef = React__default.useRef();
  React__default.useEffect(function () {
    refs.forEach(function (ref) {
      if (!ref) return;

      if (typeof ref === "function") {
        ref(targetRef.current);
      } else {
        ref.current = targetRef.current;
      }
    });
  }, [refs]);
  return targetRef;
}

var TextSize$1;

(function (TextSize) {
  TextSize["XS"] = "xs";
  TextSize["SM"] = "sm";
  TextSize["Base"] = "base";
  TextSize["LG"] = "lg";
  TextSize["XL"] = "xl";
  TextSize["XL2"] = "2xl";
  TextSize["XL3"] = "3xl";
  TextSize["XL4"] = "4xl";
  TextSize["XL5"] = "5xl";
  TextSize["XL6"] = "6xl";
})(TextSize$1 || (TextSize$1 = {}));

var unsupportedTypes = /*#__PURE__*/new Set(["checkbox", "radio", "hidden", "reset", "submit", "range", "file", "image", "color"]);

function TextInput(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? Color.Black : _ref$text,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? TextSize$1.Base : _ref$size,
      _ref$clearTextOnFocus = _ref.clearTextOnFocus,
      clearTextOnFocus = _ref$clearTextOnFocus === void 0 ? false : _ref$clearTextOnFocus,
      _ref$placeholderColor = _ref.placeholderColor,
      placeholderColor = _ref$placeholderColor === void 0 ? Color.Neutral800 : _ref$placeholderColor,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? 3 : _ref$rows,
      _ref$autosize = _ref.autosize,
      autosize = _ref$autosize === void 0 ? false : _ref$autosize,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? noop : _ref$onFocus,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      className = _ref.className,
      innerRef = _ref.innerRef,
      props = _objectWithoutPropertiesLoose(_ref, ["type", "text", "size", "clearTextOnFocus", "placeholderColor", "rows", "autosize", "onFocus", "onChange", "className", "innerRef"]);

  var cn = cx({
    "text-transparent": getDefaultColor(text) === Color.Transparent,
    "text-primary-lightest": getDefaultColor(text) === Color.PrimaryLightest,
    "text-primary-lighter": getDefaultColor(text) === Color.PrimaryLighter,
    "text-primary-light": getDefaultColor(text) === Color.PrimaryLight,
    "text-primary-base": getDefaultColor(text) === Color.Primary,
    "text-primary-dark": getDefaultColor(text) === Color.PrimaryDark,
    "text-primary-darker": getDefaultColor(text) === Color.PrimaryDarker,
    "text-primary-darkest": getDefaultColor(text) === Color.PrimaryDarkest,
    "text-secondary-lightest": getDefaultColor(text) === Color.SecondaryLightest,
    "text-secondary-lighter": getDefaultColor(text) === Color.SecondaryLighter,
    "text-secondary-light": getDefaultColor(text) === Color.SecondaryLight,
    "text-secondary-base": getDefaultColor(text) === Color.Secondary,
    "text-secondary-dark": getDefaultColor(text) === Color.SecondaryDark,
    "text-secondary-darker": getDefaultColor(text) === Color.SecondaryDarker,
    "text-secondary-darkest": getDefaultColor(text) === Color.SecondaryDarkest,
    "text-tertiary-lightest": getDefaultColor(text) === Color.TertiaryLightest,
    "text-tertiary-lighter": getDefaultColor(text) === Color.TertiaryLighter,
    "text-tertiary-light": getDefaultColor(text) === Color.TertiaryLight,
    "text-tertiary-base": getDefaultColor(text) === Color.Tertiary,
    "text-tertiary-dark": getDefaultColor(text) === Color.TertiaryDark,
    "text-tertiary-darker": getDefaultColor(text) === Color.TertiaryDarker,
    "text-tertiary-darkest": getDefaultColor(text) === Color.TertiaryDarkest,
    "text-quaternary-lightest": getDefaultColor(text) === Color.QuaternaryLightest,
    "text-quaternary-lighter": getDefaultColor(text) === Color.QuaternaryLighter,
    "text-quaternary-light": getDefaultColor(text) === Color.QuaternaryLight,
    "text-quaternary-base": getDefaultColor(text) === Color.Quaternary,
    "text-quaternary-dark": getDefaultColor(text) === Color.QuaternaryDark,
    "text-quaternary-darker": getDefaultColor(text) === Color.QuaternaryDarker,
    "text-quaternary-darkest": getDefaultColor(text) === Color.QuaternaryDarkest,
    "text-white": getDefaultColor(text) === Color.White,
    "text-neutral-100": getDefaultColor(text) === Color.Neutral100,
    "text-neutral-200": getDefaultColor(text) === Color.Neutral200,
    "text-neutral-300": getDefaultColor(text) === Color.Neutral300,
    "text-neutral-400": getDefaultColor(text) === Color.Neutral400,
    "text-neutral-500": getDefaultColor(text) === Color.Neutral500,
    "text-neutral-600": getDefaultColor(text) === Color.Neutral600,
    "text-neutral-700": getDefaultColor(text) === Color.Neutral700,
    "text-neutral-800": getDefaultColor(text) === Color.Neutral800,
    "text-black": getDefaultColor(text) === Color.Black,
    "text-success-lightest": getDefaultColor(text) === Color.SuccessLightest,
    "text-success-lighter": getDefaultColor(text) === Color.SuccessLighter,
    "text-success-light": getDefaultColor(text) === Color.SuccessLight,
    "text-success-base": getDefaultColor(text) === Color.Success,
    "text-success-dark": getDefaultColor(text) === Color.SuccessDark,
    "text-success-darker": getDefaultColor(text) === Color.SuccessDarker,
    "text-success-darkest": getDefaultColor(text) === Color.SuccessDarkest,
    "text-warning-lightest": getDefaultColor(text) === Color.WarningLightest,
    "text-warning-lighter": getDefaultColor(text) === Color.WarningLighter,
    "text-warning-light": getDefaultColor(text) === Color.WarningLight,
    "text-warning-base": getDefaultColor(text) === Color.Warning,
    "text-warning-dark": getDefaultColor(text) === Color.WarningDark,
    "text-warning-darker": getDefaultColor(text) === Color.WarningDarker,
    "text-warning-darkest": getDefaultColor(text) === Color.WarningDarkest,
    "text-alert-lightest": getDefaultColor(text) === Color.AlertLightest,
    "text-alert-lighter": getDefaultColor(text) === Color.AlertLighter,
    "text-alert-light": getDefaultColor(text) === Color.AlertLight,
    "text-alert-base": getDefaultColor(text) === Color.Alert,
    "text-alert-dark": getDefaultColor(text) === Color.AlertDark,
    "text-alert-darker": getDefaultColor(text) === Color.AlertDarker,
    "text-alert-darkest": getDefaultColor(text) === Color.AlertDarkest
  }, {
    "placeholder-transparent": placeholderColor === Color.Transparent,
    "placeholder-primary-lightest": placeholderColor === Color.PrimaryLightest,
    "placeholder-primary-lighter": placeholderColor === Color.PrimaryLighter,
    "placeholder-primary-light": placeholderColor === Color.PrimaryLight,
    "placeholder-primary-base": placeholderColor === Color.Primary,
    "placeholder-primary-dark": placeholderColor === Color.PrimaryDark,
    "placeholder-primary-darkest": placeholderColor === Color.PrimaryDarkest,
    "placeholder-secondary-lightest": placeholderColor === Color.SecondaryLightest,
    "placeholder-secondary-lighter": placeholderColor === Color.SecondaryLighter,
    "placeholder-secondary-light": placeholderColor === Color.SecondaryLight,
    "placeholder-secondary-base": placeholderColor === Color.Secondary,
    "placeholder-secondary-dark": placeholderColor === Color.SecondaryDark,
    "placeholder-secondary-darkest": placeholderColor === Color.SecondaryDarkest,
    "placeholder-tertiary-lightest": placeholderColor === Color.TertiaryLightest,
    "placeholder-tertiary-lighter": placeholderColor === Color.TertiaryLighter,
    "placeholder-tertiary-light": placeholderColor === Color.TertiaryLight,
    "placeholder-tertiary-base": placeholderColor === Color.Tertiary,
    "placeholder-tertiary-dark": placeholderColor === Color.TertiaryDark,
    "placeholder-tertiary-darkest": placeholderColor === Color.TertiaryDarkest,
    "placeholder-quaternary-lightest": placeholderColor === Color.QuaternaryLightest,
    "placeholder-quaternary-lighter": placeholderColor === Color.QuaternaryLighter,
    "placeholder-quaternary-light": placeholderColor === Color.QuaternaryLight,
    "placeholder-quaternary-base": placeholderColor === Color.Quaternary,
    "placeholder-quaternary-dark": placeholderColor === Color.QuaternaryDark,
    "placeholder-quaternary-darkest": placeholderColor === Color.QuaternaryDarkest,
    "placeholder-white": placeholderColor === Color.White,
    "placeholder-neutral-100": placeholderColor === Color.Neutral100,
    "placeholder-neutral-200": placeholderColor === Color.Neutral200,
    "placeholder-neutral-300": placeholderColor === Color.Neutral300,
    "placeholder-neutral-400": placeholderColor === Color.Neutral400,
    "placeholder-neutral-500": placeholderColor === Color.Neutral500,
    "placeholder-neutral-600": placeholderColor === Color.Neutral600,
    "placeholder-neutral-700": placeholderColor === Color.Neutral700,
    "placeholder-neutral-800": placeholderColor === Color.Neutral800,
    "placeholder-black": placeholderColor === Color.Black,
    "placeholder-success-lightest": placeholderColor === Color.SuccessLightest,
    "placeholder-success-lighter": placeholderColor === Color.SuccessLighter,
    "placeholder-success-light": placeholderColor === Color.SuccessLight,
    "placeholder-success-base": placeholderColor === Color.Success,
    "placeholder-success-dark": placeholderColor === Color.SuccessDark,
    "placeholder-success-darkest": placeholderColor === Color.SuccessDarkest,
    "placeholder-warning-lightest": placeholderColor === Color.WarningLightest,
    "placeholder-warning-lighter": placeholderColor === Color.WarningLighter,
    "placeholder-warning-light": placeholderColor === Color.WarningLight,
    "placeholder-warning-base": placeholderColor === Color.Warning,
    "placeholder-warning-dark": placeholderColor === Color.WarningDark,
    "placeholder-warning-darkest": placeholderColor === Color.WarningDarkest,
    "placeholder-alert-lightest": placeholderColor === Color.AlertLightest,
    "placeholder-alert-lighter": placeholderColor === Color.AlertLighter,
    "placeholder-alert-light": placeholderColor === Color.AlertLight,
    "placeholder-alert-base": placeholderColor === Color.Alert,
    "placeholder-alert-dark": placeholderColor === Color.AlertDark,
    "placeholder-alert-darkest": placeholderColor === Color.AlertDarkest
  }, {
    "text-xs": size === TextSize$1.XS,
    "text-sm": size === TextSize$1.SM,
    "text-base": size === TextSize$1.Base,
    "text-lg": size === TextSize$1.LG,
    "text-xl": size === TextSize$1.XL,
    "text-2xl": size === TextSize$1.XL2,
    "text-3xl": size === TextSize$1.XL3,
    "text-4xl": size === TextSize$1.XL4,
    "text-5xl": size === TextSize$1.XL5,
    "text-6xl": size === TextSize$1.XL6
  }, {
    "resize-none": !!autosize
  }, className);
  var internalRef = useRef();
  var combinedRef = useCombinedRefs(innerRef, internalRef);
  var initialValue = useRef(props.value);

  var _React$useState = useState(props.value),
      value = _React$useState[0],
      setValue = _React$useState[1];

  useEffect(function () {
    if (initialValue.current === props.value) return;
    if (value === props.value) return;
    setValue(props.value);
    initialValue.current = props.value;
  }, [props, props.value, value]);

  function handleFocus(event) {
    if (combinedRef && clearTextOnFocus) {
      setValue("");
    }

    onFocus(event);
  }

  function handleChange(event) {
    setValue(event.target.value);
    onChange(event);
  }

  if (unsupportedTypes.has(type)) {
    throw new Error("TextInput type not supported: " + type);
  }

  useTextareaAutosize(combinedRef, autosize, value);

  if (type === "multiline") {
    return /*#__PURE__*/createElement(Frame, Object.assign({
      as: "textarea",
      className: cn,
      innerRef: combinedRef,
      onFocus: handleFocus,
      rows: rows,
      value: value,
      onChange: handleChange
    }, props));
  }

  return /*#__PURE__*/createElement(Frame, Object.assign({
    as: "input",
    type: type,
    className: cn,
    innerRef: combinedRef,
    onFocus: handleFocus,
    onChange: handleChange,
    value: value
  }, props));
}

function getDOMNode(id) {
  var $el = document.querySelector("#" + id);
  if ($el) return $el;
  $el = document.createElement("div");
  $el.setAttribute("id", id);
  document.body.append($el);
  return $el;
}

function getSpacing$1(space) {
  switch (space) {
    case "px":
      return "space-y-px";

    case "-px":
      return "-space-y-px";

    case 1:
      return "space-y-1";

    case 2:
      return "space-y-2";

    case 3:
      return "space-y-3";

    case 4:
      return "space-y-4";

    case 5:
      return "space-y-5";

    case 6:
      return "space-y-6";

    case 8:
      return "space-y-8";

    case 10:
      return "space-y-10";

    case 12:
      return "space-y-12";

    case 16:
      return "space-y-16";

    case 20:
      return "space-y-20";

    case 24:
      return "space-y-24";

    case 32:
      return "space-y-32";

    case 40:
      return "space-y-40";

    case 48:
      return "space-y-48";

    case 56:
      return "space-y-56";

    case 64:
      return "space-y-64";

    case -1:
      return "-space-y-1";

    case -2:
      return "-space-y-2";

    case -3:
      return "-space-y-3";

    case -4:
      return "-space-y-4";

    case -5:
      return "-space-y-5";

    case -6:
      return "-space-y-6";

    case -8:
      return "-space-y-8";

    case -10:
      return "-space-y-10";

    case -12:
      return "-space-y-12";

    case -16:
      return "-space-y-16";

    case -20:
      return "-space-y-20";

    case -24:
      return "-space-y-24";

    case -32:
      return "-space-y-32";

    case -40:
      return "-space-y-40";

    case -48:
      return "-space-y-48";

    case -56:
      return "-space-y-56";

    case -64:
      return "-space-y-64";

    case 0:
      return "space-y-0";

    default:
      return "";
  }
}

function Stack(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      space = _ref.space,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "space"]);

  var cn = cx(getSpacing$1(space), className);
  return /*#__PURE__*/createElement(Flex, Object.assign({
    alignment: FlexAlignment.Stretch
  }, props, {
    direction: FlexDirection.Vertical,
    className: cn
  }));
}

function useLockBodyScroll() {
  useLayoutEffect(function () {
    var originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = "hidden";
    return function () {
      document.body.style.overflow = originalStyle;
    };
  }, []);
}

function createPromise() {
  var resolve;
  var promise = new Promise(function (resolver) {
    resolve = resolver;
  });
  return {
    promise: promise,
    resolve: resolve
  };
}

function useAutofocus() {
  var $element = useRef();
  useEffect(function () {
    var _$element$current, _$element$current$que;

    return (_$element$current = $element.current) === null || _$element$current === void 0 ? void 0 : (_$element$current$que = _$element$current.querySelector("[data-focus]")) === null || _$element$current$que === void 0 ? void 0 : _$element$current$que.focus();
  }, []);
  return $element;
}

var dialog = function dialog(options) {
  try {
    var $element = getDOMNode("baseline-dialog");

    var _createPromise = createPromise(),
        promise = _createPromise.promise,
        resolve = _createPromise.resolve;

    render$1( /*#__PURE__*/createElement(Dialog, {
      options: options,
      promise: {
        promise: promise,
        resolve: resolve
      }
    }), $element);
    return Promise.resolve(promise).then(function (value) {
      unmountComponentAtNode($element);
      return value;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
/**
 * Render the specific Dialog component based on the type defined in the
 * options.
 */


function Dialog(_ref) {
  var options = _ref.options,
      promise = _ref.promise;

  switch (options.type) {
    case "alert":
      {
        return /*#__PURE__*/createElement(DialogAlert, {
          options: options,
          promise: promise
        });
      }

    case "confirm":
      {
        return /*#__PURE__*/createElement(DialogConfirm, {
          options: options,
          promise: promise
        });
      }

    case "prompt":
      {
        return /*#__PURE__*/createElement(DialogPrompt, {
          options: options,
          promise: promise
        });
      }

    default:
      {
        throw new Error("Invalid dialog type.");
      }
  }
}

function DialogWrapper(props) {
  var id = useRef(Date.now()).current;
  useLockBodyScroll();
  return /*#__PURE__*/createElement(Backdrop, {
    bg: Color.White,
    innerRef: props.innerRef
  }, /*#__PURE__*/createElement(FocusLock, {
    returnFocus: true
  }, /*#__PURE__*/createElement(Stack, {
    role: "dialog",
    "aria-modal": "true",
    "aria-labelledby": props.labelledBy,
    "aria-describedby": id,
    space: 4,
    p: 6,
    shadow: Shadow.Large,
    bg: Color.White,
    corners: Corners.LargeRounded,
    border: Color.Neutral400,
    className: "overflow-y-scroll scrolling-touch max-w-xl mx-auto"
  }, /*#__PURE__*/createElement(Frame, {
    id: id
  }, props.message), props.type === "prompt" && props.input, /*#__PURE__*/createElement(Inline, {
    space: 4,
    distribution: FlexDistribution.End
  }, props.actions))));
}

function DialogAlert(_ref2) {
  var _actions$close;

  var options = _ref2.options,
      promise = _ref2.promise;
  var actions = options.actions,
      message = options.message,
      _options$wrapper = options.wrapper,
      Wrapper = _options$wrapper === void 0 ? DialogWrapper : _options$wrapper;
  var $wrapper = useAutofocus();
  var handleCloseClick = useCallback(function () {
    if (!promise.resolve) {
      throw new Error("The resolve function is not defined.");
    }

    promise.resolve({
      action: "close"
    });
  }, [promise]);
  var close = (_actions$close = actions === null || actions === void 0 ? void 0 : actions.close) !== null && _actions$close !== void 0 ? _actions$close : /*#__PURE__*/createElement(Button, {
    onClick: noop,
    color: Color.Primary,
    variant: ButtonVariant.Outline
  }, /*#__PURE__*/createElement(Text, {
    color: Color.Primary
  }, "Close"));
  return /*#__PURE__*/createElement(Wrapper, {
    type: "alert",
    labelledBy: options.labelledBy,
    innerRef: $wrapper,
    message: message,
    close: handleCloseClick,
    actions: /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/cloneElement(close, {
      onClick: handleCloseClick,
      "data-focus": true
    }))
  });
}

function DialogConfirm(_ref3) {
  var _actions$cancel, _actions$confirm;

  var options = _ref3.options,
      promise = _ref3.promise;
  var actions = options.actions,
      message = options.message,
      _options$wrapper2 = options.wrapper,
      Wrapper = _options$wrapper2 === void 0 ? DialogWrapper : _options$wrapper2;
  var $wrapper = useAutofocus();
  var handleConfirmClick = useCallback(function () {
    if (!promise.resolve) {
      throw new Error("The resolve function is not defined.");
    }

    promise.resolve({
      action: "confirm"
    });
  }, [promise]);
  var handleCancelClick = useCallback(function () {
    if (!promise.resolve) {
      throw new Error("The resolve function is not defined.");
    }

    promise.resolve({
      action: "cancel"
    });
  }, [promise]);
  var cancel = (_actions$cancel = actions === null || actions === void 0 ? void 0 : actions.cancel) !== null && _actions$cancel !== void 0 ? _actions$cancel : /*#__PURE__*/createElement(Button, {
    onClick: noop,
    color: Color.Warning,
    variant: ButtonVariant.Outline
  }, /*#__PURE__*/createElement(Text, {
    color: Color.Warning
  }, "Cancel"));
  var confirm = (_actions$confirm = actions === null || actions === void 0 ? void 0 : actions.confirm) !== null && _actions$confirm !== void 0 ? _actions$confirm : /*#__PURE__*/createElement(Button, {
    onClick: noop,
    color: Color.Primary,
    variant: ButtonVariant.Outline
  }, /*#__PURE__*/createElement(Text, {
    color: Color.Primary
  }, "Confirm"));
  return /*#__PURE__*/createElement(Wrapper, {
    type: "confirm",
    labelledBy: options.labelledBy,
    innerRef: $wrapper,
    confirm: handleConfirmClick,
    cancel: handleCancelClick,
    message: message,
    actions: /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/cloneElement(cancel, {
      onClick: handleCancelClick,
      "data-focus": true
    }), /*#__PURE__*/cloneElement(confirm, {
      onClick: handleConfirmClick
    }))
  });
}

function DialogPrompt(_ref4) {
  var _actions$cancel2, _actions$submit;

  var options = _ref4.options,
      promise = _ref4.promise;
  var actions = options.actions,
      message = options.message,
      _options$wrapper3 = options.wrapper,
      Wrapper = _options$wrapper3 === void 0 ? DialogWrapper : _options$wrapper3,
      _options$input = options.input,
      input = _options$input === void 0 ? {} : _options$input,
      defaultValue = options.defaultValue;

  var _React$useState = useState(defaultValue !== null && defaultValue !== void 0 ? defaultValue : ""),
      value = _React$useState[0],
      setValue = _React$useState[1];

  var handleSubmitClick = useCallback(function () {
    if (!promise.resolve) {
      throw new Error("The resolve function is not defined.");
    }

    promise.resolve({
      action: "submit",
      value: value
    });
  }, [promise, value]);
  var handleCancelClick = useCallback(function () {
    if (!promise.resolve) {
      throw new Error("The resolve function is not defined.");
    }

    promise.resolve({
      action: "cancel"
    });
  }, [promise]);
  var handleChange = useCallback(function (event) {
    setValue(event.target.value);
  }, [setValue]);
  var cancel = (_actions$cancel2 = actions === null || actions === void 0 ? void 0 : actions.cancel) !== null && _actions$cancel2 !== void 0 ? _actions$cancel2 : /*#__PURE__*/createElement(Button, {
    onClick: noop,
    color: Color.Warning,
    variant: ButtonVariant.Outline
  }, /*#__PURE__*/createElement(Text, {
    color: Color.Warning
  }, "Cancel"));
  var submit = (_actions$submit = actions === null || actions === void 0 ? void 0 : actions.submit) !== null && _actions$submit !== void 0 ? _actions$submit : /*#__PURE__*/createElement(Button, {
    onClick: noop,
    color: Color.Primary,
    variant: ButtonVariant.Outline
  }, /*#__PURE__*/createElement(Text, {
    color: Color.Primary
  }, "Submit"));
  return /*#__PURE__*/createElement(Wrapper, {
    type: "prompt",
    labelledBy: options.labelledBy,
    message: message,
    cancel: handleCancelClick,
    submit: handleSubmitClick,
    change: setValue,
    input: /*#__PURE__*/createElement(TextInput, Object.assign({
      border: Color.Neutral700,
      className: "w-full",
      corners: Corners.MediumRounded,
      p: [1, 2],
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus: true
    }, input, {
      value: value,
      onChange: handleChange
    })),
    actions: /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/cloneElement(cancel, {
      onClick: handleCancelClick
    }), /*#__PURE__*/cloneElement(submit, {
      onClick: handleSubmitClick
    }))
  });
}

var GridFlow;

(function (GridFlow) {
  GridFlow["Row"] = "row";
  GridFlow["Col"] = "col";
  GridFlow["RowDense"] = "row dense";
  GridFlow["ColDense"] = "col dense";
})(GridFlow || (GridFlow = {}));

function Grid(_ref) {
  var className = _ref.className,
      _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? 0 : _ref$gap,
      _ref$flow = _ref.flow,
      flow = _ref$flow === void 0 ? GridFlow.Row : _ref$flow,
      _ref$col = _ref.col,
      col = _ref$col === void 0 ? "none" : _ref$col,
      _ref$row = _ref.row,
      row = _ref$row === void 0 ? "none" : _ref$row,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "gap", "flow", "col", "row"]);

  var cn = cx("grid", {
    "grid-flow-row": flow === GridFlow.Row,
    "grid-flow-col": flow === GridFlow.Col,
    "grid-flow-row-dense": flow === GridFlow.RowDense,
    "grid-flow-col-dense": flow === GridFlow.ColDense
  }, {
    "grid-cols-1": col === 1,
    "grid-cols-2": col === 2,
    "grid-cols-3": col === 3,
    "grid-cols-4": col === 4,
    "grid-cols-5": col === 5,
    "grid-cols-6": col === 6,
    "grid-cols-7": col === 7,
    "grid-cols-8": col === 8,
    "grid-cols-9": col === 9,
    "grid-cols-10": col === 10,
    "grid-cols-11": col === 11,
    "grid-cols-12": col === 12,
    "grid-cols-none": col === "none"
  }, {
    "grid-rows-1": row === 1,
    "grid-rows-2": row === 2,
    "grid-rows-3": row === 3,
    "grid-rows-4": row === 4,
    "grid-rows-5": row === 5,
    "grid-rows-6": row === 6,
    "grid-rows-none": row === "none"
  }, !Array.isArray(gap) ? {
    "gap-0": gap === 0,
    "gap-1": gap === 1,
    "gap-2": gap === 2,
    "gap-3": gap === 3,
    "gap-4": gap === 4,
    "gap-5": gap === 5,
    "gap-6": gap === 6,
    "gap-8": gap === 8,
    "gap-10": gap === 10,
    "gap-12": gap === 12,
    "gap-16": gap === 16,
    "gap-20": gap === 20,
    "gap-24": gap === 24,
    "gap-32": gap === 32,
    "gap-40": gap === 40,
    "gap-48": gap === 48,
    "gap-56": gap === 56,
    "gap-64": gap === 64,
    "gap-px": gap === "px"
  } : {
    "row-gap-0": gap[1] === 0,
    "row-gap-1": gap[1] === 1,
    "row-gap-2": gap[1] === 2,
    "row-gap-3": gap[1] === 3,
    "row-gap-4": gap[1] === 4,
    "row-gap-5": gap[1] === 5,
    "row-gap-6": gap[1] === 6,
    "row-gap-8": gap[1] === 8,
    "row-gap-10": gap[1] === 10,
    "row-gap-12": gap[1] === 12,
    "row-gap-16": gap[1] === 16,
    "row-gap-20": gap[1] === 20,
    "row-gap-24": gap[1] === 24,
    "row-gap-32": gap[1] === 32,
    "row-gap-40": gap[1] === 40,
    "row-gap-48": gap[1] === 48,
    "row-gap-56": gap[1] === 56,
    "row-gap-64": gap[1] === 64,
    "row-gap-px": gap[1] === "px",
    "col-gap-0": gap[0] === 0,
    "col-gap-1": gap[0] === 1,
    "col-gap-2": gap[0] === 2,
    "col-gap-3": gap[0] === 3,
    "col-gap-4": gap[0] === 4,
    "col-gap-5": gap[0] === 5,
    "col-gap-6": gap[0] === 6,
    "col-gap-8": gap[0] === 8,
    "col-gap-10": gap[0] === 10,
    "col-gap-12": gap[0] === 12,
    "col-gap-16": gap[0] === 16,
    "col-gap-20": gap[0] === 20,
    "col-gap-24": gap[0] === 24,
    "col-gap-32": gap[0] === 32,
    "col-gap-40": gap[0] === 40,
    "col-gap-48": gap[0] === 48,
    "col-gap-56": gap[0] === 56,
    "col-gap-64": gap[0] === 64,
    "col-gap-px": gap[0] === "px"
  }, className);
  return /*#__PURE__*/createElement(Frame, Object.assign({
    className: cn
  }, props));
}

function getBoundingClientRect(element) {
  if (element) return element.getBoundingClientRect();
  return {
    bottom: 0,
    height: 0,
    left: 0,
    right: 0,
    top: 0,
    width: 0,
    x: 0,
    y: 0
  };
}

function useBoundingClientRect(element) {
  var _useState = useState(getBoundingClientRect()),
      rect = _useState[0],
      setRect = _useState[1];

  useLayoutEffect(function updateRect() {
    function handleResize() {
      var $element = element.current;
      if (!$element) return;
      setRect(getBoundingClientRect($element));
    }

    handleResize();
    var $element = element.current;
    if (!$element) return;

    if ("ResizeObserver" in window) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore ResizeObserver is not typed as global but it exists in browser
      var resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe($element);
      return function () {
        if (!resizeObserver) return;
        resizeObserver.disconnect();
        resizeObserver = null;
      };
    }

    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, [element, setRect]);
  return rect;
}

function useEventListener(eventName, handler, element) {
  useEffect(function () {
    var node = element !== null && element !== void 0 ? element : document;
    var isSupported = node.addEventListener;
    if (!isSupported) return;
    node.addEventListener(eventName, handler);
    return function () {
      if (!node) return;
      node.removeEventListener(eventName, handler);
    };
  }, [eventName, handler, element]);
}

function useOnKeyPress(key, handler, node) {
  var listener = useCallback(function (event) {
    return event.key === key && handler(event);
  }, [key, handler]);
  useEventListener("keydown", listener, node);
}

function useOnEscapePress(handler) {
  useOnKeyPress("Escape", handler);
}

function useOnClickOutside(ref, handler) {
  var listener = React__default.useCallback(function (event) {
    if (!ref.current || ref.current.contains(event.target)) return;
    handler(event);
  }, [ref, handler]);
  React__default.useEffect(function () {
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return function () {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [listener]);
}

var MenuContext = /*#__PURE__*/createContext(null);

function useMenuContext() {
  var context = useContext(MenuContext);

  if (context === null) {
    throw new Error("Menu components should be wrapped in the Menu");
  }

  return context;
}

function Menu(props) {
  var _React$useState = useState(false),
      isContentOpen = _React$useState[0],
      setIsContentOpen = _React$useState[1];

  var _React$useState2 = useState(null),
      focusIndex = _React$useState2[0],
      setFocusIndex = _React$useState2[1];

  var _React$useState3 = useState([]),
      items = _React$useState3[0],
      setItems = _React$useState3[1];

  var _React$useState4 = useState("idle"),
      direction = _React$useState4[0],
      setDirection = _React$useState4[1];

  var triggerId = useId();
  var contentId = useId();
  var triggerRef = useRef();
  var index = focusIndex === null ? 0 : items.indexOf(focusIndex);
  var register = useCallback(function (itemId) {
    setItems(function (ids) {
      return ids.concat(itemId);
    });
  }, []);
  var moveFocus = useCallback(function (direction) {
    if (direction === "start") return setFocusIndex(items[0]);
    if (direction === "end") return setFocusIndex(items[items.length - 1]);

    if (direction === "next") {
      return setFocusIndex(items[index === items.length - 1 ? 0 : index + 1]);
    }

    setFocusIndex(items[index === 0 ? items.length - 1 : index - 1]);
  }, [index, items]);
  var openContent = useCallback(function () {
    setIsContentOpen(true);
  }, []);
  var closeContent = useCallback(function () {
    setIsContentOpen(false);
  }, []);
  useEffect(function () {
    if (!isContentOpen) return;
    if (direction === "idle") return;
    if (items.length === 0) return;
    moveFocus(direction);
    setDirection("idle");
  }, [isContentOpen, direction, moveFocus, items.length]);
  useEffect(function () {
    if (!isContentOpen) return;
    return function () {
      return setItems([]);
    };
  }, [isContentOpen]);
  return /*#__PURE__*/createElement(MenuContext.Provider, {
    value: useMemo(function () {
      return {
        triggerId: triggerId,
        contentId: contentId,
        triggerRef: triggerRef,
        isContentOpen: isContentOpen,
        openContent: openContent,
        closeContent: closeContent,
        focusIndex: focusIndex,
        setDirection: setDirection,
        register: register
      };
    }, [closeContent, contentId, focusIndex, isContentOpen, openContent, setDirection, register, triggerId])
  }, /*#__PURE__*/createElement(Inset, Object.assign({}, props, {
    variant: "relative"
  })));
}

function Trigger(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["className"]);

  var _useMenuContext = useMenuContext(),
      triggerId = _useMenuContext.triggerId,
      triggerRef = _useMenuContext.triggerRef,
      contentId = _useMenuContext.contentId,
      isContentOpen = _useMenuContext.isContentOpen,
      openContent = _useMenuContext.openContent,
      closeContent = _useMenuContext.closeContent,
      setDirection = _useMenuContext.setDirection;

  var handleClick = useCallback(function () {
    isContentOpen ? closeContent() : openContent();
    setDirection("start");
  }, [closeContent, isContentOpen, openContent, setDirection]);
  var handleKeyDown = useCallback(function (event) {
    switch (event.key) {
      case "ArrowDown":
        event.preventDefault();
        openContent();
        setDirection("start");
        break;

      case "ArrowUp":
        event.preventDefault();
        openContent();
        setDirection("end");
        break;
    }
  }, [openContent, setDirection]);
  return /*#__PURE__*/createElement(Touchable, Object.assign({}, props, {
    className: cx("focus:shadow-outline", className),
    innerRef: triggerRef,
    id: triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": isContentOpen,
    "aria-controls": contentId,
    onClick: handleClick !== null && handleClick !== void 0 ? handleClick : noop,
    onKeyDown: handleKeyDown,
    tabIndex: isContentOpen ? -1 : 0
  }));
}

function Content(_ref2) {
  var _ref2$offset = _ref2.offset,
      offset = _ref2$offset === void 0 ? 0 : _ref2$offset,
      children = _ref2.children,
      props = _objectWithoutPropertiesLoose(_ref2, ["offset", "children"]);

  var _useMenuContext2 = useMenuContext(),
      triggerId = _useMenuContext2.triggerId,
      contentId = _useMenuContext2.contentId,
      triggerRef = _useMenuContext2.triggerRef,
      isContentOpen = _useMenuContext2.isContentOpen,
      closeContent = _useMenuContext2.closeContent;

  var contentRef = useRef();
  var rect = useBoundingClientRect(triggerRef);
  useOnEscapePress(useCallback(function () {
    var _triggerRef$current;

    closeContent();
    (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.focus();
  }, [closeContent, triggerRef]));
  useOnClickOutside(contentRef, useCallback(function (event) {
    if (event.target === triggerRef.current) return;
    closeContent();
  }, [closeContent, triggerRef]));
  if (!isContentOpen) return null;
  return /*#__PURE__*/createElement(Inset, Object.assign({
    bg: Color.White,
    p: [2, 4],
    shadow: Shadow.Large,
    position: "top left"
  }, props, {
    innerRef: contentRef,
    zIndex: 50,
    variant: "absolute",
    id: contentId,
    "aria-labelledby": triggerId,
    role: "menu",
    style: {
      top: rect.height + offset
    }
  }), children);
}

function Item(props) {
  var id = useId();

  var _useMenuContext3 = useMenuContext(),
      closeContent = _useMenuContext3.closeContent,
      triggerRef = _useMenuContext3.triggerRef,
      setDirection = _useMenuContext3.setDirection,
      focusIndex = _useMenuContext3.focusIndex,
      register = _useMenuContext3.register;

  var itemRef = useRef();
  var handleKeyDown = useCallback(function (event) {
    var _itemRef$current, _triggerRef$current2;

    switch (event.key) {
      case "ArrowDown":
        event.preventDefault();
        return setDirection("next");

      case "ArrowUp":
        event.preventDefault();
        return setDirection("prev");

      case "Home":
        return setDirection("start");

      case "End":
        return setDirection("end");

      case " ":
      case "Enter":
        var child = (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 ? void 0 : _itemRef$current.firstElementChild;
        if (!child) return;
        event.preventDefault();
        return child.click();

      case "Tab":
        closeContent();
        return (_triggerRef$current2 = triggerRef.current) === null || _triggerRef$current2 === void 0 ? void 0 : _triggerRef$current2.focus();
    }
  }, [closeContent, setDirection, triggerRef]);
  var handleClick = useCallback(function (event) {
    if (props.onClick && typeof props.onClick === "function") props.onClick(event);
    closeContent();
  }, [props, closeContent]);
  useLayoutEffect(function () {
    var _itemRef$current2;

    if (id === focusIndex) (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 ? void 0 : _itemRef$current2.focus();
  }, [focusIndex, id]);
  useEffect(function () {
    if (id) register(id);
  }, [id, register]);
  return /*#__PURE__*/createElement(Frame, Object.assign({}, props, {
    innerRef: itemRef,
    tabIndex: -1,
    role: "menuitem",
    onKeyDown: handleKeyDown,
    onClick: handleClick
  }));
}

Menu.Trigger = Trigger;
Menu.Content = Content;
Menu.Item = Item;

function Modal(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["className"]);

  var cn = cx("overflow-y-scroll scrolling-touch", className);
  return /*#__PURE__*/createElement(Frame, Object.assign({
    "aria-modal": "true",
    p: 12,
    bg: Color.White,
    shadow: Shadow.Large,
    className: cn
  }, props));
}

var Portal = function Portal(_ref) {
  var children = _ref.children,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "baseline-portal" : _ref$id;
  return /*#__PURE__*/createPortal(children, getDOMNode(id));
};

function forwardRef(render) {
  var forwarded = /*#__PURE__*/forwardRef$1(render);
  forwarded.displayName = render.displayName || render.name;
  return forwarded;
}

var Direction;

(function (Direction) {
  Direction["Horizontal"] = "horizontal";
  Direction["HorizontalReverse"] = "horizontal-reverse";
  Direction["Vertical"] = "vertical";
  Direction["VerticalReverse"] = "vertical-reverse";
})(Direction || (Direction = {}));

var SegmentedControlSize;

(function (SegmentedControlSize) {
  SegmentedControlSize["ExtraSmall"] = "xs";
  SegmentedControlSize["Small"] = "s";
  SegmentedControlSize["Base"] = "base";
  SegmentedControlSize["Large"] = "l";
  SegmentedControlSize["ExtraLarge"] = "xl";
})(SegmentedControlSize || (SegmentedControlSize = {}));

var SegmentedControlState;

(function (SegmentedControlState) {
  SegmentedControlState["Normal"] = "normal";
  SegmentedControlState["Disabled"] = "disabled";
  SegmentedControlState["Loading"] = "loading";
})(SegmentedControlState || (SegmentedControlState = {}));

var SegmentedControlContext = /*#__PURE__*/createContext({
  childClassName: "",
  size: SegmentedControlSize.Base
});

function getPaddingY$1(size) {
  if (size === SegmentedControlSize.ExtraSmall) return 1;
  if (size === SegmentedControlSize.ExtraLarge) return 3;
  return 2;
}

function getPaddingX$1(size) {
  if (size === SegmentedControlSize.ExtraSmall) return 6;
  if (size === SegmentedControlSize.ExtraLarge) return 12;
  return 8;
}

function Group(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? Color.Primary : _ref$color,
      _ref$corners = _ref.corners,
      corners = _ref$corners === void 0 ? Corners.SmallRounded : _ref$corners,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? SegmentedControlSize.Base : _ref$size,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? SegmentedControlState.Normal : _ref$state,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "color", "corners", "size", "state"]);

  var cn = cx("flex flex-row items-center justify-center", className);
  var childClassName = cx("appearance-none", "select-none", "border border-solid", // Cursor States
  {
    "cursor-pointer": state === SegmentedControlState.Normal,
    "cursor-wait": state === SegmentedControlState.Loading,
    "cursor-not-allowed": state === SegmentedControlState.Disabled
  }, // Size
  {
    "text-sm": size === SegmentedControlSize.ExtraSmall || size === SegmentedControlSize.Small,
    "text-base": size === SegmentedControlSize.Base,
    "text-lg": size === SegmentedControlSize.Large || size === SegmentedControlSize.ExtraLarge
  }, // Corners
  {
    "rounded-none": corners === Corners.Square,
    "first:rounded-l-full last:rounded-r-full": corners === Corners.FullRounded,
    "first:rounded-l-sm last:rounded-r-sm": corners === Corners.SmallRounded,
    "first:rounded-l last:rounded-r": corners === Corners.MediumRounded,
    "first:rounded-l-lg last:rounded-r-lg": corners === Corners.LargeRounded
  }, // Solid
  {
    "bg-primary-base border-primary-base text-primary-light hover:text-primary-base hover:bg-light-base": color === Color.Primary
  }, {
    "bg-secondary-base border-secondary-base text-secondary-light hover:text-secondary-base hover:bg-light-base": color === Color.Secondary
  }, {
    "bg-tertiary-base border-tertiary-base text-tertiary-light hover:text-tertiary-base hover:bg-light-base": color === Color.Tertiary
  }, {
    "bg-success-base border-success-base text-success-light hover:text-success-base hover:bg-light-base": color === Color.Success
  }, {
    "bg-danger-base border-danger-base text-danger-light hover:text-danger-base hover:bg-light-base": color === Color.Alert
  }, {
    "bg-warning-base border-warning-base text-warning-light hover:text-warning-base hover:bg-light-base": color === Color.Warning
  }, {
    "bg-dark-base text-light-base border-dark-base text-light-base hover:text-dark-base hover:bg-light-base": color === Color.Black
  }, {
    "bg-light-base text-dark-base border-light-base text-dark-base hover:text-light-base hover:bg-dark-base": color === Color.White
  });
  return /*#__PURE__*/createElement(SegmentedControlContext.Provider, {
    value: {
      childClassName: childClassName,
      size: size
    }
  }, /*#__PURE__*/createElement(Frame, Object.assign({
    as: "div",
    shadow: Shadow.None,
    className: cn
  }, props)));
}

var Item$1 = /*#__PURE__*/forwardRef(function Item(_ref2, reference) {
  var className = _ref2.className,
      children = _ref2.children,
      props = _objectWithoutPropertiesLoose(_ref2, ["className", "children"]);

  var _React$useContext = useContext(SegmentedControlContext),
      childClassName = _React$useContext.childClassName,
      size = _React$useContext.size;

  var cn = cx(childClassName, className);
  var commonProperties = {
    shadow: Shadow.None,
    py: getPaddingY$1(size),
    px: getPaddingX$1(size)
  };
  return /*#__PURE__*/createElement(Frame, Object.assign({
    as: "button",
    ref: reference,
    className: cn,
    children: children
  }, commonProperties, props));
});

function Skeleton(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? Color.Neutral100 : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 0 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      alt = _ref.alt,
      className = _ref.className,
      children = _ref.children,
      style = _ref.style,
      _ref$animated = _ref.animated,
      animated = _ref$animated === void 0 ? false : _ref$animated,
      props = _objectWithoutPropertiesLoose(_ref, ["color", "size", "width", "height", "alt", "className", "children", "style", "animated"]);

  return /*#__PURE__*/createElement(Frame, Object.assign({
    className: [className, {
      "animate-pulse": animated
    }]
  }, props, {
    bg: color,
    style: _extends({}, style, {
      width: width,
      height: height
    })
  }), /*#__PURE__*/createElement(Text, {
    srOnly: true
  }, alt), children);
}

function Spacer() {
  return /*#__PURE__*/createElement("div", {
    style: {
      flexGrow: 1
    }
  });
}

function computeValue(item, column) {
  if (column.accessor) {
    return column.accessor(item, column.name);
  } else {
    return item[column.name];
  }
}

function render(value, column, item) {
  if (column.render) {
    var Component = column.render;
    return /*#__PURE__*/createElement(Component, {
      value: value,
      item: item
    });
  }

  return value;
}

var Table = function Table(_ref) {
  var _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      className = _ref.className,
      td = _ref.td,
      th = _ref.th,
      props = _objectWithoutPropertiesLoose(_ref, ["columns", "data", "className", "td", "th"]);

  var cn = cx(className);
  return /*#__PURE__*/createElement(Frame, Object.assign({
    as: "table",
    className: cn
  }, props), /*#__PURE__*/createElement("thead", null, /*#__PURE__*/createElement("tr", null, columns.map(function (column, i) {
    return /*#__PURE__*/createElement(Frame, Object.assign({
      as: "th",
      key: i
    }, column.th, th), column.label);
  }))), /*#__PURE__*/createElement("tbody", null, data.map(function (item, i) {
    return /*#__PURE__*/createElement("tr", {
      key: i
    }, columns.map(function (column, j) {
      return /*#__PURE__*/createElement(Frame, Object.assign({
        as: "td",
        key: j
      }, column.td, td), render(computeValue(item, column), column, item));
    }));
  })));
};

function idGeneratorFactory(prefix) {
  if (prefix === void 0) {
    prefix = "";
  }

  var counter = 1;
  return function () {
    return "baseline-" + prefix + counter++;
  };
}

var HORIZONTAL = "x";
var VERTICAL = "y";
var PLACE_CONFIG = {
  top: {
    axis: VERTICAL,
    factor: -1
  },
  bottom: {
    axis: VERTICAL,
    factor: 1
  },
  right: {
    axis: HORIZONTAL,
    factor: 1
  },
  left: {
    axis: HORIZONTAL,
    factor: -1
  }
};

function useTooltip() {
  var _React$useState = useState(false),
      shouldShow = _React$useState[0],
      setShouldShow = _React$useState[1];

  var handleClick = useCallback(function () {
    setShouldShow(!shouldShow);
  }, [setShouldShow, shouldShow]);
  var handleMouseEnter = useCallback(function () {
    setShouldShow(true);
  }, [setShouldShow]);
  var handleMouseLeave = useCallback(function () {
    return setShouldShow(false);
  }, [setShouldShow]);
  var handlers = {
    handleClick: handleClick,
    handleMouseEnter: handleMouseEnter,
    handleMouseLeave: handleMouseLeave
  };
  return {
    shouldShow: shouldShow,
    handlers: handlers
  };
}

function useTooltipPosition(tooltipRef, childRef, shouldShow, place) {
  var SEPARATOR = 10;

  var _React$useState2 = useState(false),
      isShown = _React$useState2[0],
      setIsShown = _React$useState2[1];

  var _React$useState3 = useState({}),
      position = _React$useState3[0],
      setPosition = _React$useState3[1];

  var getTooltipCenter = useCallback(function () {
    if (!tooltipRef.current) return {
      x: 0,
      y: 0
    };
    var tooltipRect = tooltipRef.current.getBoundingClientRect();
    var x = tooltipRect.width / 2;
    var y = tooltipRect.height / 2;
    return {
      x: x,
      y: y
    };
  }, [tooltipRef]);
  var getCenter = useCallback(function () {
    if (!childRef.current) return {
      x: 0,
      y: 0
    };
    var tooltipCenter = getTooltipCenter();
    var childRect = childRef.current.getBoundingClientRect();
    var pageScroll = Math.abs(document.body.getBoundingClientRect().top);
    var x = childRect.x + childRect.width / 2 - tooltipCenter.x;
    var y = childRect.y + childRect.height / 2 - tooltipCenter.y + pageScroll;
    return {
      x: x,
      y: y
    };
  }, [childRef, getTooltipCenter]);
  var getPositionFix = useCallback(function () {
    var _ref2;

    if (!childRef.current || !tooltipRef.current) return {
      x: 0,
      y: 0
    };
    var childRect = childRef.current.getBoundingClientRect();
    var tooltipRect = tooltipRef.current.getBoundingClientRect();
    var _PLACE_CONFIG$place = PLACE_CONFIG[place],
        axis = _PLACE_CONFIG$place.axis,
        factor = _PLACE_CONFIG$place.factor;

    var _ref = axis === HORIZONTAL ? {
      tooltipAxis: tooltipRect.width,
      childAxis: childRect.width
    } : {
      tooltipAxis: tooltipRect.height,
      childAxis: childRect.height
    },
        tooltipAxis = _ref.tooltipAxis,
        childAxis = _ref.childAxis;

    var fix = (tooltipAxis / 2 + childAxis / 2 + SEPARATOR) * factor;
    return _ref2 = {}, _ref2[axis] = fix, _ref2;
  }, [childRef, tooltipRef, place]);
  var updateCoordinates = useCallback(function (center, fix) {
    var top = (center.y || 0) + (fix.y || 0);
    var left = (center.x || 0) + (fix.x || 0);
    setPosition({
      transform: "translate3d(" + left + "px, " + top + "px, 0px)"
    });
  }, []);
  var handleMouseMove = useCallback(function (event) {
    var center = getTooltipCenter();
    var pageScroll = Math.abs(document.body.getBoundingClientRect().top);
    var x = event.clientX - center.x;
    var y = event.clientY - center.y + pageScroll;
    var mouse = {
      x: x,
      y: y
    };
    var positionFix = getPositionFix();
    updateCoordinates(mouse, positionFix);
  }, [getPositionFix, getTooltipCenter, updateCoordinates]);
  useEffect(function () {
    if (shouldShow) {
      var center = getCenter();
      var fix = getPositionFix();
      updateCoordinates(center, fix);
    }

    setIsShown(shouldShow);
  }, [getCenter, updateCoordinates, getPositionFix, shouldShow]);
  return {
    isShown: isShown,
    position: position,
    handleMouseMove: handleMouseMove
  };
}

function useTooltipArrow(withArrow, place, offset) {
  var _ref4;

  var borderColor = ["top", "right", "bottom", "left"].map(function (side) {
    return side === place ? "currentColor" : "transparent";
  }).join(" ");

  var _ref3 = PLACE_CONFIG[place] || "top",
      axis = _ref3.axis;

  var centerAxis = axis === HORIZONTAL ? "top" : "left";
  var marginAxis = "margin" + centerAxis.charAt(0).toUpperCase() + centerAxis.slice(1);
  var margin = -4 + offset + "px";
  return _ref4 = {
    display: withArrow ? "block" : "none"
  }, _ref4[place] = "100%", _ref4[centerAxis] = "50%", _ref4[marginAxis] = margin, _ref4.borderColor = borderColor, _ref4;
}

var ToggleEvent;

(function (ToggleEvent) {
  ToggleEvent["Hover"] = "hover";
  ToggleEvent["Click"] = "click";
})(ToggleEvent || (ToggleEvent = {}));

var Place;

(function (Place) {
  Place["Top"] = "top";
  Place["Bottom"] = "bottom";
  Place["Left"] = "left";
  Place["Right"] = "right";
})(Place || (Place = {})); // Styles Section


var baseCn = ["absolute", "top-0", "left-0", "block", "text-white", "text-center", "z-10", "transition", "transition-opacity", "duration-300"];
var baseCss = {
  minWidth: "120px"
};
var genUniqueId = /*#__PURE__*/idGeneratorFactory("tooltip-");

function TooltipChildren(props) {
  var innerRef = useRef(undefined);
  var combinedRef = useCombinedRefs(props.innerRef, innerRef);
  var children = Children.only(props.children);

  function onMouseEnter(event) {
    var childreOnMouseEnter = children.props.onMouseEnter;
    props.handlers.onMouseEnter(event);
    if (childreOnMouseEnter) childreOnMouseEnter(event);
  }

  function onMouseLeave(event) {
    var childrenOnMouseLeave = children.props.onMouseLeave;
    props.handlers.onMouseLeave(event);
    if (childrenOnMouseLeave) childrenOnMouseLeave(event);
  }

  if (!children) return null;
  var clonedChildren = /*#__PURE__*/cloneElement(children, _extends({}, props.handlers, {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    innerRef: combinedRef
  }));
  return /*#__PURE__*/createElement(Fragment, null, clonedChildren);
}

function Tooltip(_ref) {
  var children = _ref.children,
      label = _ref.label,
      _ref$toggleEvent = _ref.toggleEvent,
      toggleEvent = _ref$toggleEvent === void 0 ? ToggleEvent.Hover : _ref$toggleEvent,
      _ref$place = _ref.place,
      place = _ref$place === void 0 ? Place.Top : _ref$place,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset,
      _ref$fixed = _ref.fixed,
      fixed = _ref$fixed === void 0 ? true : _ref$fixed,
      _ref$withArrow = _ref.withArrow,
      withArrow = _ref$withArrow === void 0 ? true : _ref$withArrow,
      _ref$scrollable = _ref.scrollable,
      scrollable = _ref$scrollable === void 0 ? false : _ref$scrollable,
      _ref$maxSize = _ref.maxSize,
      maxSize = _ref$maxSize === void 0 ? {
    maxWidth: "auto",
    maxHeight: "auto"
  } : _ref$maxSize,
      className = _ref.className,
      _ref$p = _ref.p,
      p = _ref$p === void 0 ? 1 : _ref$p,
      _ref$bg = _ref.bg,
      bg = _ref$bg === void 0 ? Color.Neutral700 : _ref$bg,
      _ref$corners = _ref.corners,
      corners = _ref$corners === void 0 ? Corners.MediumRounded : _ref$corners,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "label", "toggleEvent", "place", "offset", "fixed", "withArrow", "scrollable", "maxSize", "className", "p", "bg", "corners"]);

  var childRef = useRef(undefined);
  var innerRef = useRef(undefined);
  var combinedRef = useCombinedRefs(props.innerRef, innerRef);
  var id = useRef(props.id || genUniqueId());
  var arrowColorCn = cx({
    "text-transparent": getDefaultColor(bg) === Color.Transparent,
    "text-primary-lighter": getDefaultColor(bg) === Color.PrimaryLighter,
    "text-primary-light": getDefaultColor(bg) === Color.PrimaryLight,
    "text-primary-base": getDefaultColor(bg) === Color.Primary,
    "text-primary-dark": getDefaultColor(bg) === Color.PrimaryDark,
    "text-primary-darker": getDefaultColor(bg) === Color.PrimaryDarker,
    "text-secondary-lighter": getDefaultColor(bg) === Color.SecondaryLighter,
    "text-secondary-light": getDefaultColor(bg) === Color.SecondaryLight,
    "text-secondary-base": getDefaultColor(bg) === Color.Secondary,
    "text-secondary-dark": getDefaultColor(bg) === Color.SecondaryDark,
    "text-secondary-darker": getDefaultColor(bg) === Color.SecondaryDarker,
    "text-tertiary-lighter": getDefaultColor(bg) === Color.TertiaryLighter,
    "text-tertiary-light": getDefaultColor(bg) === Color.TertiaryLight,
    "text-tertiary-base": getDefaultColor(bg) === Color.Tertiary,
    "text-tertiary-dark": getDefaultColor(bg) === Color.TertiaryDark,
    "text-tertiary-darker": getDefaultColor(bg) === Color.TertiaryDarker,
    "text-white": getDefaultColor(bg) === Color.White,
    "text-neutral-100": getDefaultColor(bg) === Color.Neutral100,
    "text-neutral-200": getDefaultColor(bg) === Color.Neutral200,
    "text-neutral-300": getDefaultColor(bg) === Color.Neutral300,
    "text-neutral-400": getDefaultColor(bg) === Color.Neutral400,
    "text-neutral-500": getDefaultColor(bg) === Color.Neutral500,
    "text-neutral-600": getDefaultColor(bg) === Color.Neutral600,
    "text-neutral-700": getDefaultColor(bg) === Color.Neutral700,
    "text-neutral-800": getDefaultColor(bg) === Color.Neutral800,
    "text-black": getDefaultColor(bg) === Color.Black,
    "text-success-lighter": getDefaultColor(bg) === Color.SuccessLighter,
    "text-success-light": getDefaultColor(bg) === Color.SuccessLight,
    "text-success-base": getDefaultColor(bg) === Color.Success,
    "text-success-dark": getDefaultColor(bg) === Color.SuccessDark,
    "text-success-darker": getDefaultColor(bg) === Color.SuccessDarker,
    "text-warning-lighter": getDefaultColor(bg) === Color.WarningLighter,
    "text-warning-light": getDefaultColor(bg) === Color.WarningLight,
    "text-warning-base": getDefaultColor(bg) === Color.Warning,
    "text-warning-dark": getDefaultColor(bg) === Color.WarningDark,
    "text-warning-darker": getDefaultColor(bg) === Color.WarningDarker,
    "text-alert-lighter": getDefaultColor(bg) === Color.AlertLighter,
    "text-alert-light": getDefaultColor(bg) === Color.AlertLight,
    "text-alert-base": getDefaultColor(bg) === Color.Alert,
    "text-alert-dark": getDefaultColor(bg) === Color.AlertDark,
    "text-alert-darker": getDefaultColor(bg) === Color.AlertDarker
  });

  var _useTooltip = useTooltip(),
      shouldShow = _useTooltip.shouldShow,
      _useTooltip$handlers = _useTooltip.handlers,
      handleClick = _useTooltip$handlers.handleClick,
      handleMouseEnter = _useTooltip$handlers.handleMouseEnter,
      handleMouseLeave = _useTooltip$handlers.handleMouseLeave;

  var _useTooltipPosition = useTooltipPosition(combinedRef, childRef, shouldShow, place),
      isShown = _useTooltipPosition.isShown,
      position = _useTooltipPosition.position,
      handleMouseMove = _useTooltipPosition.handleMouseMove;

  var tooltipArrowStyles = useTooltipArrow(withArrow, place, offset);
  var handlers = useMemo(function () {
    return _extends({
      onMouseLeave: handleMouseLeave
    }, toggleEvent === ToggleEvent.Click ? {
      onClick: handleClick
    } : {
      onMouseEnter: handleMouseEnter
    }, !fixed ? {
      onMouseMove: handleMouseMove
    } : {});
  }, [toggleEvent, fixed, handleClick, handleMouseEnter, handleMouseLeave, handleMouseMove]);

  var style = _extends({}, baseCss, position, maxSize);

  var cn = cx.apply(void 0, baseCn.concat([isShown ? "opacity-100" : "opacity-0", scrollable && "overflow-scroll", className]));
  var arrowCn = cx("absolute", "border-solid", "border-4", arrowColorCn);

  var arrowStyle = _extends({}, tooltipArrowStyles);

  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(TooltipChildren, {
    innerRef: childRef,
    handlers: handlers
  }, children), shouldShow && /*#__PURE__*/createElement(Portal, {
    id: id.current
  }, /*#__PURE__*/createElement(Frame, Object.assign({
    innerRef: combinedRef,
    p: p,
    bg: bg,
    corners: corners,
    className: cn,
    style: style
  }, props), label, /*#__PURE__*/createElement(Frame, {
    style: arrowStyle,
    className: arrowCn
  }))));
}

function createPromise$1() {
  var resolve;
  var promise = new Promise(function (resolver) {
    resolve = resolver;
  });
  return {
    promise: promise,
    resolve: resolve
  };
}

var ToastContext = /*#__PURE__*/createContext([]);
var SetToastContext = /*#__PURE__*/createContext(noop);

function useToastList() {
  return useContext(ToastContext);
}

function useSetToast() {
  return useContext(SetToastContext);
}

function useToasts() {
  return [useToastList(), useSetToast()];
}

function useToast() {
  var setToasts = useSetToast();

  if (setToasts === noop) {
    throw new Error("useToast must be used within a ToastProvider");
  }

  var addToast = useCallback(function (newToast) {
    var id = Date.now();
    setToasts(function (toasts) {
      return toasts.concat(_extends({}, newToast, {
        id: id
      }));
    });

    if (newToast.action) {
      var _createPromise = createPromise$1(),
          promise = _createPromise.promise,
          resolve = _createPromise.resolve;

      if (resolve) {
        promiseResolutions.set(id, resolve);
      }

      return promise;
    }
  }, [setToasts]);
  return addToast;
}

var DEFAULT_TIME = 5000;
var promiseResolutions = /*#__PURE__*/new Map();

function ToastProvider(_ref) {
  var children = _ref.children;

  var _React$useState = useState([]),
      toasts = _React$useState[0],
      setToasts = _React$useState[1];

  return /*#__PURE__*/createElement(ToastContext.Provider, {
    value: toasts
  }, /*#__PURE__*/createElement(SetToastContext.Provider, {
    value: setToasts
  }, children));
}

function ToastContainer(props) {
  var _useToasts = useToasts(),
      toasts = _useToasts[0],
      setToasts = _useToasts[1];

  function removeToast(_ref2) {
    var id = _ref2.id,
        action = _ref2.action,
        actionClicked = _ref2.actionClicked;

    if (action) {
      var resolve = promiseResolutions.get(id);

      if (resolve) {
        promiseResolutions["delete"](id);
        resolve(actionClicked);
      }
    }

    setToasts(function (currentToast) {
      return currentToast.filter(function (toast) {
        return toast.id !== id;
      });
    });
  }

  return /*#__PURE__*/createElement(Fragment, null, toasts.map(function (toast) {
    return /*#__PURE__*/createElement(Toast, Object.assign({
      key: toast.id
    }, toast, props, {
      removeToast: removeToast
    }));
  }));
}

function Toast(_ref3) {
  var label = _ref3.label,
      action = _ref3.action,
      close = _ref3.close,
      render = _ref3.render,
      removeToast = _ref3.removeToast,
      _ref3$preserve = _ref3.preserve,
      preserve = _ref3$preserve === void 0 ? false : _ref3$preserve,
      _ref3$time = _ref3.time,
      time = _ref3$time === void 0 ? DEFAULT_TIME : _ref3$time,
      id = _ref3.id,
      rest = _objectWithoutPropertiesLoose(_ref3, ["label", "action", "close", "render", "removeToast", "preserve", "time", "id"]);

  useEffect(function () {
    if (preserve) return;
    var timer = setTimeout(function () {
      removeToast({
        id: id,
        action: action,
        actionClicked: false
      });
    }, time);
    return function () {
      timer && clearTimeout(timer);
    };
  }, [action, id, preserve, removeToast, time]);
  var handleClose = useCallback(function () {
    removeToast({
      id: id,
      action: action,
      actionClicked: false
    });
  }, [id, action]);
  var handleAction = useCallback(function () {
    removeToast({
      id: id,
      action: action,
      actionClicked: true
    });
  }, [id, action]);

  if (render) {
    if (typeof render === "function") {
      var Render = render;
      return /*#__PURE__*/createElement(Flex, Object.assign({}, rest), /*#__PURE__*/createElement(Render, {
        closeToast: handleClose,
        action: handleAction
      }));
    }

    return /*#__PURE__*/createElement(Flex, Object.assign({}, rest), render);
  }

  return /*#__PURE__*/createElement(Flex, Object.assign({}, rest), label, action && /*#__PURE__*/cloneElement(action, {
    onClick: handleAction
  }), close && /*#__PURE__*/cloneElement(close, {
    onClick: handleClose
  }));
}

function Icon(_ref) {
  var children = _ref.children,
      color = _ref.color,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? "span" : _ref$as,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "color", "as", "className"]);

  var cn = cx({
    "text-transparent": getDefaultColor(color) === Color.Transparent,
    "text-primary-lightest": getDefaultColor(color) === Color.PrimaryLightest,
    "text-primary-lighter": getDefaultColor(color) === Color.PrimaryLighter,
    "text-primary-light": getDefaultColor(color) === Color.PrimaryLight,
    "text-primary-base": getDefaultColor(color) === Color.Primary,
    "text-primary-dark": getDefaultColor(color) === Color.PrimaryDark,
    "text-primary-darker": getDefaultColor(color) === Color.PrimaryDarker,
    "text-primary-darkest": getDefaultColor(color) === Color.PrimaryDarkest,
    "text-secondary-lightest": getDefaultColor(color) === Color.SecondaryLightest,
    "text-secondary-lighter": getDefaultColor(color) === Color.SecondaryLighter,
    "text-secondary-light": getDefaultColor(color) === Color.SecondaryLight,
    "text-secondary-base": getDefaultColor(color) === Color.Secondary,
    "text-secondary-dark": getDefaultColor(color) === Color.SecondaryDark,
    "text-secondary-darker": getDefaultColor(color) === Color.SecondaryDarker,
    "text-secondary-darkest": getDefaultColor(color) === Color.SecondaryDarkest,
    "text-tertiary-lightest": getDefaultColor(color) === Color.TertiaryLightest,
    "text-tertiary-lighter": getDefaultColor(color) === Color.TertiaryLighter,
    "text-tertiary-light": getDefaultColor(color) === Color.TertiaryLight,
    "text-tertiary-base": getDefaultColor(color) === Color.Tertiary,
    "text-tertiary-dark": getDefaultColor(color) === Color.TertiaryDark,
    "text-tertiary-darker": getDefaultColor(color) === Color.TertiaryDarker,
    "text-tertiary-darkest": getDefaultColor(color) === Color.TertiaryDarkest,
    "text-quaternary-lightest": getDefaultColor(color) === Color.QuaternaryLightest,
    "text-quaternary-lighter": getDefaultColor(color) === Color.QuaternaryLighter,
    "text-quaternary-light": getDefaultColor(color) === Color.QuaternaryLight,
    "text-quaternary-base": getDefaultColor(color) === Color.Quaternary,
    "text-quaternary-dark": getDefaultColor(color) === Color.QuaternaryDark,
    "text-quaternary-darker": getDefaultColor(color) === Color.QuaternaryDarker,
    "text-quaternary-darkest": getDefaultColor(color) === Color.QuaternaryDarkest,
    "text-white": getDefaultColor(color) === Color.White,
    "text-neutral-100": getDefaultColor(color) === Color.Neutral100,
    "text-neutral-200": getDefaultColor(color) === Color.Neutral200,
    "text-neutral-300": getDefaultColor(color) === Color.Neutral300,
    "text-neutral-400": getDefaultColor(color) === Color.Neutral400,
    "text-neutral-500": getDefaultColor(color) === Color.Neutral500,
    "text-neutral-600": getDefaultColor(color) === Color.Neutral600,
    "text-neutral-700": getDefaultColor(color) === Color.Neutral700,
    "text-neutral-800": getDefaultColor(color) === Color.Neutral800,
    "text-black": getDefaultColor(color) === Color.Black,
    "text-success-lightest": getDefaultColor(color) === Color.SuccessLightest,
    "text-success-lighter": getDefaultColor(color) === Color.SuccessLighter,
    "text-success-light": getDefaultColor(color) === Color.SuccessLight,
    "text-success-base": getDefaultColor(color) === Color.Success,
    "text-success-dark": getDefaultColor(color) === Color.SuccessDark,
    "text-success-darker": getDefaultColor(color) === Color.SuccessDarker,
    "text-success-darkest": getDefaultColor(color) === Color.SuccessDarkest,
    "text-warning-lightest": getDefaultColor(color) === Color.WarningLightest,
    "text-warning-lighter": getDefaultColor(color) === Color.WarningLighter,
    "text-warning-light": getDefaultColor(color) === Color.WarningLight,
    "text-warning-base": getDefaultColor(color) === Color.Warning,
    "text-warning-dark": getDefaultColor(color) === Color.WarningDark,
    "text-warning-darker": getDefaultColor(color) === Color.WarningDarker,
    "text-warning-darkest": getDefaultColor(color) === Color.WarningDarkest,
    "text-alert-lightest": getDefaultColor(color) === Color.AlertLightest,
    "text-alert-lighter": getDefaultColor(color) === Color.AlertLighter,
    "text-alert-light": getDefaultColor(color) === Color.AlertLight,
    "text-alert-base": getDefaultColor(color) === Color.Alert,
    "text-alert-dark": getDefaultColor(color) === Color.AlertDark,
    "text-alert-darker": getDefaultColor(color) === Color.AlertDarker,
    "text-alert-darkest": getDefaultColor(color) === Color.AlertDarkest
  }, className);
  var Component = as;
  return /*#__PURE__*/createElement(Component, Object.assign({
    className: cn
  }, props), children);
}

var useSSRLayoutEffect = typeof window === "undefined" ? useEffect : useLayoutEffect;

function useIsClient() {
  var _React$useState = useState(false),
      isClient = _React$useState[0],
      setIsClient = _React$useState[1];

  useSSRLayoutEffect(function () {
    setIsClient(true);
  }, []);
  return isClient;
}

function formatQuery(mediaQuery) {
  var query = mediaQuery;

  if (!query.startsWith("(")) {
    query = "(" + query;
  }

  if (!query.endsWith(")")) {
    query = query + ")";
  }

  return query;
}

function useMatchMedia(mediaQuery, defaultMatch) {
  var query = formatQuery(mediaQuery);

  var _React$useState = useState(defaultMatch),
      match = _React$useState[0],
      setMatch = _React$useState[1];

  var handler = useCallback(function () {
    setMatch(window.matchMedia(query).matches);
  }, [query]);
  useSSRLayoutEffect(function () {
    var matchMedia = window.matchMedia(query);
    setMatch(function () {
      return matchMedia.matches;
    });
    matchMedia.addListener(handler);
    return function () {
      matchMedia.removeListener(handler);
    };
  }, [query, handler, match]);
  return match;
}

export { Accordion, AccordionContent, AccordionGroup, AccordionTitle, AccordionTogglerContext, AccordionValueContext, Avatar, AvatarGroup, AvatarPlaceholder, AvatarSize, Backdrop, Button, ButtonSize, ButtonState, ButtonVariant, Cell, Center, Color, Corners, Dialog, DialogWrapper, Direction, Flex, FlexAlignment, FlexDirection, FlexDistribution, Frame, Grid, GridFlow, Group, Icon, Image, Inline, Inset, Item$1 as Item, Menu, Modal, Place, Portal, SegmentedControlSize, SegmentedControlState, SetToastContext, Shadow, Skeleton, Spacer, Stack, Table, Text, TextDecoration, TextInput, TextLeading, TextSize, TextTracking, TextTransform, TextWeight, TextWhitespace, TextWordBreak, Toast, ToastContainer, ToastContext, ToastProvider, Tooltip, Touchable, createResource, dialog, noop, createImageResource as preloadImage, promiseResolutions, useAccordion, useAccordionToggle, useAccordionValue, useBoundingClientRect, useCombinedRefs, useIsClient, useLockBodyScroll, useMatchMedia, useOnClickOutside, useOnEscapePress, useOnKeyPress, useSSRLayoutEffect, useSetToast, useTextareaAutosize, useToast, useToastList, useToasts };